import React, { Component, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import SglContext from '../SglContext'
import ReactModal from "react-modal";

import $ from 'jquery';
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";

import "./entries.css";

// IMPORT IMAGES
import warning_red from "../images/warning_red.gif";
import indicator_icon from "../images/Indicator.gif";
import red_dot from "../images/red-dot.png";
import green_dot from "../images/green-dot.png";
import search_icon from "../images/loupe.png";
import delete_image from "../images/trash.png";


//API END POINTS
// const sgl_webservice_edit_entry = Sgl.nestApiUrl+'/entries/getEditEntry';
// const sgl_webservice_save_entry = Sgl.nestApiUrl+'/entries/saveEditEntry';
// const sgl_webservice_shows_list = Sgl.nestApiUrl+'/shows';
// const user_info_url = Sgl.nestApiUrl+'/users/getLoggedInUser';
// const sgl_webservice_iphone = Sgl.sglApiUrl+'/iphonev2/addentryv2/';
// const sgl_webservice_validate_remove_rider = Sgl.nestApiUrl+'/entries/validateRemoveRider';
// const sgl_webservice_validate_horse_change = Sgl.nestApiUrl+'/entries/validateHorseChange';
// const sgl_webservice_validate_save_entry = Sgl.nestApiUrl+'/entries/validateSaveEntry';

var UpdateModal = ReactModal;

//Set Genders Array
const horse_genders_array = ["Gelding", "Mare", "Stallion"];

//Set Genders Array
const horse_greens_array = ["First Year", "Second Year"];

//Set Types Array
const horse_types_array = ["Small", "Small Junior", "Medium", "Large", "Large Junior"];

// const membership_organizations = ['EC', 'FEI', 'USEF', 'USHJA', 'BIO Security', "Int'l Hunter Derby"];
const associated_membership_organizations = ['USHJA'];

const new_horse_data_initial = {
  horse_id: -10,
  name:'',
  sex:'',
  color: '', 
  age:'',
  height: '',
  green: '',
  type:'',
  memberships:[]
};
const countries_array = [
  'United States',
  'Canada',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Saint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'C?te d\'Ivoire',
  'Croatia',
  'Cuba',
  'Cura?ao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'R?union',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barth?lemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

const new_person_data_initial = {
  people_id: -10,
  isfarmrto: false,
  company_name: '',
  first:'',
  last_name:'',
  lf_name:'',
  fl_name:'',
  address: '', 
  city:'',
  state: '',
  postal_code: '',
  country:'',
  email_address: '',
  mobile_phone: '',
  phonenumber: '',
  memberships:[],
  is_created: false
};

const active_css = {
  header: "active_block class-details, primary-header class-details-header sgl-primary-header",
  title: "sgl-no-text-shadow ring-name sgl-nm-ring-name",
  changeBtn: "sgl-no-text-shadow sgl-arrow ring-arrow change_selection",  
}

const inactive_css = {
  header: "class-details, primary-header class-details-header active_block add_entry_options",
  title: "sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title",
  changeBtn: "sgl-no-text-shadow sgl-arrow ring-arrow change_selection",  //display_none
}

class EditEntry extends React.Component{

  get sgl_webservice_edit_entry() {
    return this.context.nestApiUrl + '/entries/getEditEntry';
  }

  get sgl_webservice_save_entry() {
    return this.context.nestApiUrl + '/entries/saveEditEntry';
  }

  get sgl_webservice_shows_list() {
    return this.context.nestApiUrl + '/shows';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  get sgl_webservice_iphone() {
    return this.context.sglApiUrl + '/iphonev2/addentryv2/';
  }

  get sgl_webservice_validate_remove_rider() {
    return this.context.nestApiUrl + '/entries/validateRemoveRider';
  }

  get sgl_webservice_validate_horse_change() {
    return this.context.nestApiUrl + '/entries/validateHorseChange';
  }

  get sgl_webservice_validate_save_entry() {
    return this.context.nestApiUrl + '/entries/validateSaveEntry';
  }

  state = {
    current_show: this.getQueryVariable('sid'),
    horses_list: [],
    current_entry: {},
    show_company: [],
    membership_organizations: [],
    linked_people: [],
    people_id: "-1",
    max_rider_limit: "-1",
    people_organizations: [],
    show_data: {},
    // governing_organization:"USEF",

    loading: true,

    current_section:'horse',

    selected_horse: {},

    selected_riders: [],
    selected_trainer: {},
    selected_owner: {},
    selected_prize: {},
    selected_responsible: {},
    selected_ec_responsible: {},
    digital_signature_people:[],

    error_message:"",  //for invalid entry

    save_error_message: "",
    restrict_junior_riders: false
  }
  constructor(props){
    super(props);
    this.setSelectedHorse = this.setSelectedHorse.bind(this);
    this.changeSelection = this.changeSelection.bind(this);
    this.setSelectedPeople = this.setSelectedPeople.bind(this);
    this.getLinkedParents = this.getLinkedParents.bind(this);
  }

  componentDidMount(){
      this.getEditEntry();
  }

  setSelectedHorse(horse){
    this.setState({
      selected_horse: horse
    })
  }

  setSelectedPeople(people){  //people  = array of selected peoples
    this.setState({
      selected_riders: people[0],
      selected_trainer: people[1],
      selected_owner: people[2],
      selected_prize: people[3],
      selected_responsible: people[4],
      selected_ec_responsible: people[5],
    })
  }

  async getLinkedParents(peopleId, customerId, field='rider') {  
      if (!peopleId || !customerId) return { linked_people: [], pending_linked_people: [] };
      try {
          const response = await axios.get('add-entry/getLinkedParentsFromCloud', {
              params: {
                  people_id: peopleId,
                  customer_id: customerId, 
              }
          });
          return response.data || { linked_people: [], pending_linked_people: [] };
      } catch (error) {
          console.error('Error fetching linked parents:', error);
          return { linked_people: [], pending_linked_people: [] };
      }
    }
  
  getEditEntry(){
      axios.get(this.sgl_webservice_edit_entry,{
          params : {
              show_id : this.state.current_show,
              customer_id: this.context.company_id,
              entry_id:this.getQueryVariable("eid"),
              team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }).then(async results => {
              if(results.data?.error != ""){
                this.setState({
                  error_message: results.data.error,
                  loading:false
                })
              }
              else{
                document.title = "Edit Entry " + results.data.entry.number + " - " + results.data.entry.horse;
                for (const entryRider of results.data.entry.EntryRiders) {
                    const rider = results.data.linked_people.find(p => p.people_id === entryRider.rider_id);
                    // If the rider is a junior, fetch their parents
                    if (rider && rider.is_junior) {
                      const parents = await this.getLinkedParents(rider.people_id, this.context.company_id);
                      const { linked_people = [], pending_linked_people = [] } = parents.data || {};
                      const allParents = [...linked_people, ...pending_linked_people];
                      const primaryParent = allParents.find(p => p.is_primary == 1) || {};
                      rider.parents_list = allParents;
                      rider.parent_guardian_id = primaryParent.people_id ?? 0;
                    }
                }

                this.setState({
                    loading:false,
                    horses_list: results.data.linked_horses,
                    current_entry: results.data.entry,
                    show_company: results.data.show_company,
                    membership_organizations: results.data.horse_organizations.map((organization)=> organization.code),
                    linked_people: results.data.linked_people,
                    people_id: results.data.people_id,
                    max_rider_limit: results.data.show_data.max_rider_limit,
                    people_organizations: results.data.people_organizations,
                    show_data: results.data.show_data,
                    selected_horse: results.data.linked_horses.find((horse) => horse.horse_id == results.data.entry.horse_id),
                    restrict_junior_riders: results.data.restrict_junior_riders == '1'?true:false,
                })
              }
      })
  }

  getQueryVariable(variable)
  {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
        }
        return(false);
  }

  changeSelection(section_name){
    this.setState({
      current_section:section_name
    })
  }

  setDigitalSignature(people){
    this.setState({
      digital_signature_people: people,
    }, () => this.saveEntry() )
  }

  saveEntry(){
    const selected_people = [
      ...this.state.selected_riders,
      this.state.selected_trainer,
      this.state.selected_owner,
      this.state.selected_prize,
      this.state.selected_responsible,
      this.state.selected_ec_responsible
    ].filter( (people) => people?.is_updated || people?.people_id <= 0); //only updated ones

    let new_parents = this.state.selected_riders.filter(r => r.parent_guardian_id < 0)

    new_parents.forEach(rider => {
    // For each rider in the 'new_parents' list, look into its 'parents_list'
    if (rider.parents_list && rider.parents_list.length > 0) {
        const matchingParent = rider.parents_list.find(parentPeople =>
            parentPeople.people_id === rider.parent_guardian_id
        );

        if (matchingParent) {
            selected_people.push(matchingParent);
        }
      }
    });

    //making unique ones only to save them in backend
    var unique_people_ids = [...new Set( selected_people.map( (people) => people.people_id ) )];
    const people = unique_people_ids.map( (id) => { return selected_people.find( (people) => people.people_id == id ) });

    const data = {
      people,
      entry_data: {
        EntryRiders: this.state.selected_riders.filter( rider => rider?.people_id).map( (er) =>{
          return {
            rider_id: er?.people_id,
            parent_guardian_id: er?.parent_guardian_id ?? 0
          }
        }),
        trainer_id: this.state.selected_trainer.people_id,
        entryowner_id: this.state.selected_owner.people_id,
        prizemoneyrecipient_id: this.state.selected_prize.people_id,
        responsibleparty_id: this.state.selected_responsible.people_id,
        ec_responsibleparty_id: this.state.selected_ec_responsible?.people_id,
      },
      horse: this.state.selected_horse,
      company_id: this.state.show_company.company_id,
      entry_id: this.state.current_entry.entry_id,
      show_id: this.state.show_data.show_id,
      digital_signature_people: this.state.digital_signature_people,
      team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
    }
  
    const encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
    axios.post(this.sgl_webservice_save_entry,{
      entry_data : encoded_data
    }).then( response => {
        if(response.data.success){
          this.changeSelection('thank');
          this.setState({
            save_error_message: "",
          })
        }
        else{
          this.setState({
            save_error_message: response.data.error
          })
        }
    })
  }

  currentSection(section_name){
    return this.state.current_section == section_name;
  }
  

  render(){
      if(this.state.loading) return null;
      if(this.state?.error_message){
        return(
          <div className="sgl-plugin">
            <p className="required">{this.state.error_message}</p>
          <div className="credit-text">{process.env.REACT_APP_CREDIT_TEXT} <a href={process.env.REACT_APP_CREDIT_URL}>{process.env.REACT_APP_CREDIT_COMPANY}</a></div><br/>
          </div>
        )
      }
      return(
        <div className="sgl-plugin">
          {/* credit hold here */}
          <h2>Entry{" "+this.state.current_entry.number+" - "+this.state.current_entry.horse} </h2>
          <div className="credit-text">{process.env.REACT_APP_CREDIT_TEXT} <a href={process.env.REACT_APP_CREDIT_URL}>{process.env.REACT_APP_CREDIT_COMPANY}</a></div><br/>
          <div id="ringWrapper" class='ringWrapper'>
            <div className='div-responsive'>
            <div className={ this.currentSection('horse') ? active_css.header : inactive_css.header } rowNum="1">
                <p className={ this.currentSection('horse') ? active_css.title : inactive_css.title } >Select Horse</p>
                <div className={ ( this.currentSection('horse') && !this.currentSection('thank') ) ? active_css.changeBtn : inactive_css.changeBtn } >
                    { ( !this.currentSection('horse') && !this.currentSection('thank') ) && <a className="sgl-hover" onClick={()=>{ this.changeSelection('horse') }}>Change</a> }
                </div>
            </div>
            {
              this.state.current_section == 'horse' &&
              <SelectHorse 
                horses_list={this.state.horses_list} 
                entry={this.state.current_entry} 
                show_company={this.state.show_company}
                show_data={this.state.show_data}
                membership_organizations={this.state.membership_organizations}
                selected_horse={this.state.selected_horse}
                setSelectedHorse={this.setSelectedHorse}
                changeSelection={this.changeSelection}
                governing_organization={this.state.show_company?.governing_organization}
                current_show={this.state.current_show}
              />
            }


            <div className={ this.currentSection('people') ? active_css.header : inactive_css.header } rowNum="2">
              <p  className={this.currentSection('people') ? active_css.title : inactive_css.title } >Select People</p>
              <div className={ (this.currentSection('people') && !this.currentSection('thank')) ? active_css.changeBtn : inactive_css.changeBtn } >
                  { (!this.currentSection('people') && !this.currentSection('thank')) && <a className="sgl-hover" onClick={()=>{ this.changeSelection('people') }}>Change</a> }
              </div>
            </div>
            {
              this.state.current_section == 'people' && 
              <SelectPeople 
                people_list={this.state.linked_people} 
                people_id={this.state.people_id} 
                entry={this.state.current_entry} 
                max_rider_limit={this.state.max_rider_limit}
                people_organizations={this.state.people_organizations}
                governing_organization={this.state.show_company?.governing_organization}
                show_data={this.state.show_data}
                selected_horse={this.state.selected_horse}
                changeSelection={this.changeSelection}
                setSelectedPeople={this.setSelectedPeople}
                show_company={this.state.show_company}

                selected_riders={this.state.selected_riders}
                selected_trainer={this.state.selected_trainer}
                selected_owner={this.state.selected_owner}
                selected_prize={this.state.selected_prize}
                selected_responsible={this.state.selected_responsible}
                selected_ec_responsible={this.state.selected_ec_responsible}
                restrict_junior_riders={this.state.restrict_junior_riders} 
                getLinkedParents={this.getLinkedParents}
              />
            }


          <div className={ this.currentSection('signature' ) ? active_css.header : inactive_css.header } rowNum="3">
            <p  className={ this.currentSection('signature' ) ? active_css.title : inactive_css.title } >Digital Signature Verification</p>
          </div>
          {
              this.state.current_section == 'signature' && 
              <DigitalSignatureVerification 
                selected_riders={this.state.selected_riders}
                selected_trainer={this.state.selected_trainer}
                selected_owner={this.state.selected_owner}
                selected_responsible={this.state.selected_responsible}
                selected_ec_responsible={this.state.selected_ec_responsible}
                entry={this.state.current_entry}
                current_show={this.state.current_show}
                governing_organization={this.state.show_company?.governing_organization}
                saveEntry={this.saveEntry.bind(this)}
                setDigitalSignature={this.setDigitalSignature.bind(this)}
                saveErrorMessage={this.state.save_error_message}
              />
            }

          <div className={ this.currentSection('thank') ? active_css.header : inactive_css.header } rowNum="4">
            <p  className={ this.currentSection('thank') ? active_css.title : inactive_css.title } >Thank You</p>
          </div>
          {
              this.state.current_section == 'thank' && 
              <div id='step_10' className='add_entry_class add-entry-div'>             
                  <ul>    
                    <li className='entry_people_li'>
                      <p>
                        Thank you! Your request for edit entry has been submitted.
                      </p>
                    </li>
                  </ul>
              </div>
          }
          </div>
          </div>
        </div>    
      )
  }
}

class SelectHorse extends React.Component{

    get sgl_webservice_edit_entry() {
      return this.context.nestApiUrl + '/entries/getEditEntry';
    }

    get sgl_webservice_save_entry() {
      return this.context.nestApiUrl + '/entries/saveEditEntry';
    }

    get sgl_webservice_shows_list() {
      return this.context.nestApiUrl + '/shows';
    }

    get user_info_url() {
      return this.context.nestApiUrl + '/users/getLoggedInUser';
    }

    get sgl_webservice_iphone() {
      return this.context.sglApiUrl + '/iphonev2/addentryv2/';
    }

    get sgl_webservice_validate_remove_rider() {
      return this.context.nestApiUrl + '/entries/validateRemoveRider';
    }

    get sgl_webservice_validate_horse_change() {
      return this.context.nestApiUrl + '/entries/validateHorseChange';
    }

    get sgl_webservice_validate_save_entry() {
      return this.context.nestApiUrl + '/entries/validateSaveEntry';
    }

    constructor(props){
        super(props);
        let selected_horse =  this.props.horses_list.find((horse)=> horse.horse_id == ( props.selected_horse?.horse_id ? props.selected_horse?.horse_id : props.entry?.horse_id ) );
        const on_vet_hold = this.props.selected_horse?.on_vet_hold;
        this.state={
            selected_horse_id: props.selected_horse?.horse_id ? props.selected_horse?.horse_id : props.entry?.horse_id,
            selected_horse: selected_horse ? selected_horse: {},
            horses_search_list:[],  
            horse_search:"by_name",
            horse_name:"",
            horse_membership_no:"",
            txt_horse_name_disabled:false,
            txt_membership_no_disabled:true,
            horse_select_error:on_vet_hold? "Selected horse is on vet hold.":"",
            on_vet_hold:on_vet_hold,
            horse_search_org:"by_usef",
            horse_search_type:"by_name",
            horse_search_by_label: 'by USEF No.',
            txt_horse_name_disabled:false,
            txt_membership_no_disabled:true,
            horse_search_by_txt_label: 'Enter USEF No.',
            horse_search_label_th:"USEF No.",
            //show search bar
            show_search_horse:false,
            horse_search_loading:true,
            governing_organization: this.props?.governing_organization ,
            new_horse_data: JSON.parse(JSON.stringify(new_horse_data_initial)),
            horse_to_update: {},
            new_horses_count: 0,
            is_editing_horse: false,
            add_horse_error_msg: '',
            is_open_horse_modal: false,

            selected_horse_search:{},
        }

        this.setHorseSearch = this.setHorseSearch.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeHorseModal = this.closeHorseModal.bind(this);
        this.checkHorseDuplicateEntries = this.checkHorseDuplicateEntries.bind(this);
    }
    afterOpenModal() {
      // references are now sync'd and can be accessed.
      // this.subtitle.style.color = '#f00';
      
    }
  
    closeHorseModal() {
      this.setState({
        is_open_horse_modal: false,
        new_horse_data: JSON.parse(JSON.stringify(new_horse_data_initial)),
        horse_to_update: {}
      });
      // document.getElementById('add_horse_warning').style.display = "none";
    }

    getHorseUpdateMessage(horse){
        if (this.getMembershipWarning(horse.memberships)){
          return 'Click here to add this membership.';
        } else if (this.getHasMissingInfo(horse, ["name", "sex", "height"])){
          return 'There is some missing information on file. Click here to update this horse.';
        }  else {
          return 'Click here to update this horse.';
        }
    }

    getMembershipWarning(memberships = []){
        var membership_warning = false;
        memberships.forEach(membership => {
          if(!membership.membership_number || membership.membership_number == ''){
            membership_warning = true;
          }
        });
        return membership_warning;
      }
  
    getHasMissingInfo(object, mandatory_fields){
        var has_missing_info = false;
        mandatory_fields.forEach(field => {
          if(!object[field] || object[field] == ''){
            has_missing_info = true;
          }
        });
        return has_missing_info;
    }
  
    openUpdateHorseModel = (horse) => (e) => { 
        this.setState({
          is_open_horse_modal: true,
          add_horse_error_msg: '',
          new_horse_data: JSON.parse(JSON.stringify(horse)),
          horse_to_update: this.props.horses_list.find(el => el.horse_id === horse.horse_id),
          // JSON.parse(JSON.stringify(horse)),
          is_editing_horse: true
        });
        
    }

    horse_selected(from_search){
      if(this.state.selected_horse_search?.horse_id){
        const horse = this.state.selected_horse_search;
        const horse_already_exists = this.props.horses_list.find(p => p.horse_id === horse.horse_id);
        if(!horse_already_exists){
          this.props.horses_list.push(horse)
          this.setState({
            selected_horse : horse,
            selected_horse_id : horse.horse_id,
            show_search_horse:false,
          })
        }
      }
      else if(this.state.selected_horse){
        // this.setState({
        //   horses_search_list: [],
        // });
        // this.activateBlock("step_3_container");
      }
      if (!from_search && this.state.horse_search == 'by_name' && this.state.horse_name != ''){
        this.getHorseSearchData(this.state.horse_search, this.state.horse_name)
        this.setState({
          show_search_horse:true,
        })
      }
    }
    
    setHorseSearch(event){
      var membership_disabled = false;
      var horse_disabled = true;

      if (event.target.value === 'by_name'){
        horse_disabled = false;
        membership_disabled = true;
      }
      this.setState({
          horse_search : event.target.value,
          horse_search_org: event.target.value,
          txt_membership_no_disabled: membership_disabled,
          txt_horse_name_disabled: horse_disabled,
          // horse_name: '',
          // horse_membership_no: ''
      });
     
    }

    updateHorseName(evt) {
        this.setState({
          horse_name: evt.target.value
        });
    }

    updateHorseMembership(evt) {
        this.setState({
          horse_membership_no: evt.target.value
        });
    }


    setHorseLabelTh = () => {
      var organization_label = this.state.governing_organization;
      if(this.state.horse_search_type == 'by_name'){
        if(this.state.governing_organization == "EC"){
            organization_label = "Sport License";
        }else if(this.state.governing_organization == "USEF"){
            organization_label = "USEF";
        }
        organization_label = organization_label + " No.";
      } else {
        organization_label = 'USEF No.';
        if (this.state.horse_search_org == 'by_ec'){
          organization_label = 'Sport License No.';
        } else if (this.state.horse_search_org == 'by_fei'){
          organization_label = 'FEI No.';
        }
      }
      this.setState({
        horse_search_label_th: organization_label
      })
    }

    getHorseSearchData = (search_by, search_term) =>{
      //indicator on searching
      this.setState({
        horse_search_loading:true
      })

      if(search_term && search_term != ''){
        axios.get(this.sgl_webservice_iphone+'SearchHorse',{
          params : {
              search_by : search_by,
              search_term : search_term,
              company_id: this.context.company_id,
              check_duplicates: true,
              show_id: this.props.current_show,
              entry_id: this.props.entry.entry_id
          }
        }).then(results => {
          this.setHorseLabelTh();
          // document.getElementById('search-horse-please-wait').style.display = "none";
          this.setState({
            horses_search_list: results.data.horses?results.data.horses:[],
            horse_search_loading: false,
            // loading: false
          });
        })
      } else {
        // document.getElementById('search-horse-please-wait').style.display = "none";
        this.setState({
          horses_search_list: [],
        });
      }
      
    }

    getMembershipNumberToUpdate(org, memberships_list = [], object = false){
      const membership = memberships_list.find(mem => mem.organization_code === org);
      if(object) return membership;
      if (membership){
        return membership.membership_number;
      }
      return;
    }

    horseSearch = () => {
      // document.getElementById('search-horse-please-wait').style.display = "inline";
      if (this.state.horse_search == 'by_name') {
        this.getHorseSearchData(this.state.horse_search_type, this.state.horse_name);
      } else {
        this.getHorseSearchData(this.state.horse_search_org, this.state.horse_membership_no);
      }
    }

    checkHorseDuplicateEntries = async(horse_id) => {
      if(horse_id < 0 || !horse_id || !this.props.current_show){ // check duplicate fpr existing horse only ignore new horse
        return false
      }
      // check if selected horse has some existing entry
      let results = await axios.get(this.sgl_webservice_iphone+'CheckHorseForDuplicateEntries',{
        params : {
            show_id : this.props.current_show,
            horse_id : horse_id,
            company_id: this.context.company_id,
            entry_id: this.props.entry.entry_id
        }
      })
      return results?.data ?? false

    }
    
    LinkedHorses = () => {

    const onHorseSelect = async(e) => {
        let targetValue = e.target.value
        if(targetValue !== '-1'){
          let selected_horse =  this.props.horses_list.find((horse)=> horse.horse_id == targetValue );

          let error = ''
          if(selected_horse.on_vet_hold){
            error = "Selected horse is on vet hold."
          }else{
            // check if selected horse has some existing entries
            let horseHasDuplicateEntries = await this.checkHorseDuplicateEntries(selected_horse.horse_id)
            if(horseHasDuplicateEntries){// horse has duplicate entries
              error = 'The selected horse has already been entered in this show and cannot be added a second time. Please contact the show office for more information.' 
            }  
          }

          this.setState({
            selected_horse_id: targetValue,
            selected_horse: selected_horse,
            on_vet_hold: selected_horse.on_vet_hold,
            horse_select_error: error,
          })
        }
    }

    const getMembershipNumber = () => {
        var membership_no = '';
        if(this.props.show_company.governing_organization=="USEF"){
          membership_no = this.state.selected_horse.usef_no;
        }
        else if(this.props.show_company.governing_organization=="FEI"){
          membership_no = this.state.selected_horse.fei_id;
        }
        else{
          membership_no = this.state.selected_horse.ec_ppn;
        }
        if (membership_no == ''){
          membership_no = 'N/A';
        }
        return membership_no;
    }

    

    return(
        <>
          <li className='entry_people_li'>
            <p className="add-entry-p">Choose from horses that you have been associated with in the past. You can manage your horse list on Account page:</p>
          </li>
          <li className='entry_people_li'>
              <select className="selection-list" value={this.state.selected_horse_id} onChange={(e) => onHorseSelect(e)} >
              <option value="-1">Select a horse...</option>
              {
                  this.props.horses_list?.map((horse,index) => {
                      return (
                          <option value={`${horse?.horse_id}`}>
                              {horse?.name}
                          </option>
                              )
                      })
              }
              </select>
              {
                this.state.selected_horse?.horse_id &&
                <div id="detail_horse" class="detail_box">
                  <p class='link_color'><b>{this.state.selected_horse?.name}</b></p>
                  <p>{this.props.show_company.governing_organization}: {getMembershipNumber()}</p>
                  <div><a onClick={this.openUpdateHorseModel(this.state.selected_horse)}>{this.getHorseUpdateMessage(this.state.selected_horse)}</a></div>
                </div> 
              }
              
            </li>
        </>
      )
    }

    SearchHorsePrimary = () => {
      
      const showSearchHorseSecondary = (e) =>{

        if(this.state.horse_name != "" || this.state.horse_membership_no != ""){
          if (this.state.horse_search == 'by_name' && this.state.horse_name != "") {
            this.getHorseSearchData(this.state.horse_search_type, this.state.horse_name);
            this.setState({
              show_search_horse:true
            })
          } 
          else if(this.state.horse_search != 'by_name' &&  this.state.horse_membership_no != "") {
            this.getHorseSearchData(this.state.horse_search_org, this.state.horse_membership_no);
            this.setState({
              show_search_horse:true
            })
          }
        }     

      }

      const _handleHorseSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
          showSearchHorseSecondary();
        }
    }

      return(
        <ul className="search-horse-primary">
          <li className='entry_people_li'>
            <div>
                <p className="add-entry-p">Or Search for a horse:</p> 
                <input id="by_horse_field" type="radio" name="horse" class="sgl-mr-5"
                    value='by_name' onChange={this.setHorseSearch}
                    checked={this.state.horse_search === 'by_name'} 
                /> 
                <label className='add_entry_custom_label' for='by_horse_field'>  by Name</label>
                
                <br/>
                <input id="by_usef_field" type="radio" name="horse" class="sgl-mr-5"
                    value='by_usef' onChange={this.setHorseSearch}
                    checked={this.state.horse_search === 'by_usef'} 
                />
                <label className='add_entry_custom_label' for='by_usef_field'>  by USEF No.</label>
                <br/>
                <input id="by_passport_field" type="radio" name="horse" class="sgl-mr-5"
                    value='by_ec' onChange={this.setHorseSearch}
                    checked={this.state.horse_search === 'by_ec'} 
                />
                <label className='add_entry_custom_label' for='by_passport_field'>   by Passport No.</label>

                <br/>
                <input id="by_fei_field" type="radio" name="horse" class="sgl-mr-5"
                    value='by_fei' onChange={this.setHorseSearch}
                    checked={this.state.horse_search === 'by_fei'} 
                />
                <label className='add_entry_custom_label' for='by_fei_field'>   by FEI No.</label>
            </div>
          </li>
          <li className='entry_people_li'>
            <div style={{clear: "both"}}>
              <div class="txt-field-container-div">
                <label className='add_entry_label sgl-add_entry'>Horse Name</label>
                <div style={{clear: "both"}}></div>
                <div class="people_selection_div txt-field-container">
                  <input onKeyPress={evt => _handleHorseSearchKeyPress(evt)} style={{backgroundColor: this.state.txt_horse_name_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="name" id='txt_horse_name' class="input-height horse_name" value={this.state.horse_name} disabled={this.state.txt_horse_name_disabled} onChange={evt => this.updateHorseName(evt)}/>
                </div>
              </div>
              <div class="txt-field-container-div">
                <div class="people_selection_div txt-field-container">
                    
                        <label className='add_entry_label sgl-add_entry'>Membership No.</label>
                        <div style={{clear: "both"}}></div>
                        <div class="input-box txt-field-container">
                          <input onKeyPress={evt => _handleHorseSearchKeyPress(evt)} class="input-height" style={{backgroundColor: this.state.txt_membership_no_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="txt_membership_no" value={this.state.horse_membership_no} disabled={this.state.txt_membership_no_disabled} onChange={evt => this.updateHorseMembership(evt)}/>
                        </div>
                    
                </div>
              </div>
              <div class="txt-field-container-div" style={{marginTop:'18px'}}>
                <div style={{clear: "both"}}></div>
                  <button class='sgl-button' onClick={() => {showSearchHorseSecondary()}}>
                          Search
                  </button>
              </div>
            </div>
            <div style={{clear: "both"}}></div>
          </li>
          {
            this.state?.horse_select_error ?
            <li className='entry_people_li'>
              <div style={{clear: "both"}}></div>
              <div id='step_2_warning' className='required'>Please, select a horse from the drop-down list or enter Passport No. or Name to search horse.</div>
              <div id='horse_selection_warning' className='required'>{this.state.horse_select_error}</div>
            </li> : null
          }    
        </ul>
      )


    }

    SearchHorseSecondary = () => {

      const setHorseSearchType = (event) => {
        var membership_disabled = false;
        var horse_disabled = true;
  
        if (event.target.value == 'by_name'){
          horse_disabled = false;
          membership_disabled = true;
        }
        this.setState({
            horse_search_type : event.target.value,
            horse_search : event.target.value,
            txt_membership_no_disabled: membership_disabled,
            txt_horse_name_disabled: horse_disabled
        });
  
      }

      const setHorseSearchOrg = (event) => {
        var horse_search_by_label = 'by USEF No.';
        var horse_search_by_txt_label = 'Enter USEF No.';
        if (event.target.value == 'by_ec'){
          horse_search_by_label = 'by Passport No.';
          horse_search_by_txt_label = 'Enter Passport No.';
        } else if (event.target.value == 'by_fei'){
          horse_search_by_label = 'by FEI No.';
          horse_search_by_txt_label = 'Enter FEI No.';
        }
        this.setState({
            horse_search_org : event.target.value,
            horse_search_by_label: horse_search_by_label,
            horse_search_by_txt_label: horse_search_by_txt_label
        });
  
      }

    const updateHorseName = (evt) => {
        this.setState({
          horse_name: evt.target.value
        });
    }
  
      const updateHorseMembership = (evt) => {
        this.setState({
          horse_membership_no: evt.target.value
        });
    }

    const _handleHorseSearchKeyPress2 = (e)  =>  {
        if (e.key === 'Enter') {
          this.horseSearch();      
        }
    }

    const setHorse = (event) =>{
      const horse = this.state.horses_search_list.find(el => el.horse_id === event.currentTarget.value);
      if(!getHorseError(horse).hasError){
        // this.props.horses_list.push(horse)
        this.setState({
            // selected_horse : horse,
            // selected_horse_id : horse.horse_id,
            selected_horse_search : horse
          });
          //set in select as well
          // this.setDefaultPeople(horse);
      }
    }
    
    const getHorseError = (horse) => {
      let hasError = false
      let error = ''
      if(horse.on_vet_hold){
        hasError = true
        error = '\n [On vet hold]'
      }else if(horse.has_duplicate_entries){
        hasError = true
        error = '\n [The selected horse has already been entered in this show.]'
      }
      // if (this.state.governing_organization=='EC' && horse.ec_suspended) {
      //   return '\n [EC Suspended]';
      // }
      // if (this.state.governing_organization=='USEF' && horse.usef_suspended != '0'){
      //   return '\n [USEF Suspended]';
      // }
      // if (this.state.governing_organization=='FEI' && horse.fei_suspended){
      //   return '\n [FEI Suspended]';
      // }

      return {hasError, error}
    }

    const getHorseUsefNo = (horse) => {
      if(this.state.horse_search_type == 'by_name'){

        if(this.state.governing_organization == "EC"){
          return horse["ec_ppn"];
        } else if(this.state.governing_organization == "FEI"){
          return horse["fei_id"];
        } else {
          return horse["usef_no"];
        }
      } else {
        if(this.state.horse_search_label_th == "Sport License No."){
          return horse["ec_ppn"];
        } else if(this.state.horse_search_label_th == "FEI No."){
          return horse["fei_id"];
        } else {
          return horse["usef_no"];
        }
      }
    }

    const cancel_horse_search = (e) => {
      this.setState({
        horses_search_list: [],
        show_search_horse:false
      });
      //also hide whole search horse here

    }

      //not necessary warning
      const SearchWarning = () => {

        return(
        <li className='entry_people_li'>
          <div style={{clear: "both"}}></div>
          <div id='step_2_search_warning' className='required display_none'>Please select a horse to continue.</div>
        </li>
        )
      }


      return(
        // display_none add-entry-div 
        <div id='search_horse' className='add_entry_horse '>
          <ul>       
          <li className='entry_people_li'>
              <div>
                  <label className='add_entry_label'>Governing Organization</label>
                  <div style={{clear: "both"}}></div>
                  <input type="radio" id="us_ef" name="horse_search_org" class="sgl-mr-5"
                      value='by_usef' onChange={(e)=>{setHorseSearchOrg(e)}}
                      checked={this.state.horse_search_org === 'by_usef'} 
                  />
                  <label for='us_ef' className='add_entry_custom_label'>  United States Equestrian Federation (USEF)</label>
                  <br/>
                  <input type="radio" id="ec_field" name="horse_search_org" class="sgl-mr-5"
                      value='by_ec' onChange={(e)=>{setHorseSearchOrg(e)}}
                      checked={this.state.horse_search_org === 'by_ec'} 
                  />
                  <label for='ec_field' className='add_entry_custom_label'>  Equine Canada (EC)</label>

                  <br/>
                  <input type="radio" id="fei_field" name="horse_search_org" class="sgl-mr-5"
                      value='by_fei' onChange={(e)=>{setHorseSearchOrg(e)}}
                      checked={this.state.horse_search_org === 'by_fei'} 
                  />
                  <label for='fei_field' className='add_entry_custom_label'>  Federation Equestre Internationale (FEI)</label>
              </div>
            </li>       
            <li className='entry_people_li'>
              <div>
                  <label className='add_entry_label'>Search for a horse:</label>
                  <div style={{clear: "both"}}></div>
                  <input type="radio" id="by_horse_name_field" name="horse_search_type" class="sgl-mr-5"
                      value='by_name' onChange={setHorseSearchType}
                      checked={this.state.horse_search === 'by_name'} 
                  />
                  <label for='by_horse_name_field' className='add_entry_custom_label'onChange={this.setHorseSearch}>  by Name</label>
                  
                  <br/>
                  <input type="radio" id="by_selected_label" name="horse_search_type" class="sgl-mr-5"
                      value='by_govrn' onChange={setHorseSearchType}
                      checked={this.state.horse_search !== 'by_name'} 
                  />
                  <label for='by_selected_label' className='add_entry_custom_label'>  {this.state.horse_search_by_label}</label>

              </div>
            </li>
            <li className='entry_people_li'>
            <div style={{clear: "both"}}>
              <div class="txt-field-container-div">
                <label className='add_entry_label'>Enter Horse Name</label>
                <div class="people_selection_div txt-field-container">
                  <input  onKeyPress={evt => _handleHorseSearchKeyPress2(evt)} style={{backgroundColor: this.state.txt_horse_name_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="name" id='txt_search_horse_name' value={this.state.horse_name} class="input-height horse_name" disabled={this.state.txt_horse_name_disabled} onChange={evt => updateHorseName(evt)}/>

                </div>
              </div>
              <div class="txt-field-container-div">
                <div class="people_selection_div txt-field-container">
                    
                        <label className='add_entry_label'>{this.state.horse_search_by_txt_label}.</label>
                        <div style={{clear: "both"}}></div>
                        <div class="input-box txt-field-container">
                          <input  onKeyPress={evt => _handleHorseSearchKeyPress2(evt)} class="input-height" style={{backgroundColor: this.state.txt_membership_no_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="txt_search_membership_no" value={this.state.horse_membership_no} disabled={this.state.txt_membership_no_disabled} onChange={evt => updateHorseMembership(evt)}/>
                        </div>
                    
                </div>
              </div>
              
            </div>
            </li>
            <li className='entry_people_li'>
              <div style={{clear: "both"}}></div>
              <div>
                <button class='sgl-button horse_search-button' onClick={()=>{this.horseSearch();}}>
                  Search
                </button>
                { this.state.horse_search_loading &&
                  <span id="search-horse-please-wait" ><img src={indicator_icon} /></span>
                }
              </div>
            </li>
            {
              this.state.horses_search_list && this.state.horses_search_list.length == 0
              &&
              <li className='entry_people_li'>
                <p>0 records found.</p>
              </li>
            }
            {
              <li className='entry_people_li'>
              <div class="">
                <table className="table table-striped table-hover scroll_table">
                  <thead class="classes-header">                    
                    <tr class="sgl-primary-header">
                      <th style={{min_width: '20px', width: '40px'}}>*</th>
                      <th class="display_on_mobile"></th>
                      <th class="display_on_desktop">{this.state.horse_search_label_th}</th>
                      <th class="display_on_desktop">Name</th>
                      <th class="display_on_desktop">Owner</th>
                      <th class="display_on_desktop" style={{ width: '70px'}}><img src={red_dot} class="placing-icon"/><img src={green_dot} class="placing-icon"/></th>
                    </tr>
                  </thead>
                  <tbody className="table-scroll">
                  { this.state.horses_search_list && this.state.horses_search_list.length > 0 &&
                    this.state.horses_search_list?.map((data, index) => {
                      let suspended = (this.state.governing_organization=='EC' && data.ec_suspended) || (this.state.governing_organization=='USEF' && data.usef_suspended != '0') || (this.state.governing_organization=='FEI' && data.fei_suspended);
                      return (
                        <tr class="sgl-anchor">
                          <td style={{min_width: '20px', width: '40px'}} nowrap="nowrap">
                              <input type="radio" name="horse_select" 
                                  value={data.horse_id} 
                                  checked={this.state.selected_horse_search.horse_id === data.horse_id} 
                                  // onChange={(e) => this.onHorseChange(e)}
                                  disabled={getHorseError(data).hasError}
                                  onChange={setHorse}
                              />
                          </td>
                          <td class="display_on_mobile mbl_custom_row new-line" onClick={() => setHorse({currentTarget: {value: data.horse_id}})}>
                            <p class="table_row_p">
                              <span><strong>{this.state.horse_search_label_th}</strong> {getHorseUsefNo(data)}</span>
                              <span class="right-align status_icon"><img src={suspended ? red_dot: green_dot} class="placing-icon"/></span>
                              <br></br>
                              <span><strong>Name:</strong> {data.name}
                                <text class='required'>{getHorseError(data).error}</text>
                              </span>
                              <br></br>
                              <span><strong>Owner:</strong> {data.owner_name}</span>
                            </p>
                          </td>
                          <td class="display_on_desktop" onClick={() => setHorse({currentTarget: {value: data.horse_id}})}>{getHorseUsefNo(data)} </td>
                          <td class="new-line display_on_desktop" onClick={() => setHorse({currentTarget: {value: data.horse_id}})}>{data.name}
                            <text class='required'>{getHorseError(data).error}</text>
                          </td>
                          <td class="display_on_desktop" onClick={() => setHorse({currentTarget: {value: data.horse_id}})}>{data.owner_name}</td>
                          <td class="display_on_desktop" onClick={() => setHorse({currentTarget: {value: data.horse_id}})} style={{width: '40px'}}><img src={suspended ? red_dot: green_dot} class="placing-icon"/></td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                  </table>
              </div>
            </li>
            }
            <div class='continue-button-div'>
              <div>
                <span class="color-gray"><img src={red_dot} class="placing-icon"/> indicates that the USEF / EC / FEI Membership has been suspended.</span>
                <br/>
                <span class="color-gray"><img src={green_dot} class="placing-icon"/> indicates that the USEF / EC / FEI Membership is active.</span>
              </div>
              <div class='required float_right'>
                * Required Fields
              </div>
              <br class="sgl-mb-5"/>
              <button class='sgl-button float_right horse_search-button' onClick={()=>{this.horse_selected(true)}}>
                Continue
              </button>
              <button class='sgl-button float_right horse_search-button' onClick={cancel_horse_search}>
                Cancel
              </button>
          </div>
          </ul>
        </div>
      )
    }

    showSearchHorse = (e) => {
      this.setState({
        show_search_horse:true,
      })
    }

    UpdateHorseModal = () => {


      const updateNewHorseData = (evt, field, is_membership=false) => {
        var horse_data = this.state.new_horse_data;
        if (is_membership){
  
          var memberships_list = horse_data['memberships'];
  
          var membership = {
            'organization_code': field,
            'membership_number': evt.target.value,
            'is_edited': true
          }
          const i = memberships_list.findIndex(mem => mem.organization_code === field);
          if (i > -1) {
            memberships_list[i] = membership; // (2)
          } else {
            memberships_list.push(membership);
          }
        } else {
          horse_data[field+"_is_edited"]  = true;
          horse_data[field] = evt.target.value
        }
  
        this.setState({
          new_horse_data: horse_data
        });
      }     

      const handleValidateHorseResponse = (response_data) => {
        if (response_data.success) {
          var horse = this.state.new_horse_data;
          horse.is_updated = true;
          this.setState({
            is_open_horse_modal: false,
            add_horse_error_msg: '',
            selected_horse: horse,
            horse_to_update: {}
          });
          const horse_index = this.props.horses_list.findIndex((h) => h.horse_id == horse.horse_id);
          this.props.horses_list[horse_index]  = horse;
          this.props.setSelectedHorse(this.state.selected_horse)
        }
        else{
          this.setState({add_horse_error_msg: response_data.errors}); 
        }
      }

      const validateHorse = (horse_data) => {
        axios.get(this.sgl_webservice_iphone+'ValidateHorse',{
          params : {
              horse : horse_data,
              company_id: this.context.company_id
          }
        }).then(results => {
          handleValidateHorseResponse(results.data);   
        })
        
      }

      const addHorse = (e) => {
        if (this.state.new_horse_data.name == '') {
          this.setState({add_horse_error_msg: [ "Please enter Name." ]}); 
        } else if (this.state.new_horse_data.sex == ''){
          this.setState({add_horse_error_msg: [ "Please enter Sex." ]}); 
        } else if(this.state.new_horse_data.height == '') {
          this.setState({add_horse_error_msg: [ "Please enter Height." ]}); 
        } else {
          var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(this.state.new_horse_data))));
          validateHorse(encoded_data);
          
        }
        // this.calculateHeight();
      }

      const SaveCancelButtons = () => {

        return(
          <div class='continue-button-div'>
            <div class='required float_right'>
              * Required Fields
            </div>
            <br class="sgl-mb-5"/>
            <button class='sgl-button float_right horse_search-button' onClick={this.closeHorseModal}>
              Cancel
            </button>
            <button class='sgl-button float_right horse_search-button' onClick={addHorse}>
              Save
            </button>
          </div>
        )
      }

      return(
        <UpdateModal
          isOpen={this.state.is_open_horse_modal}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeHorseModal}
          className="mymodal modal-width-responsive"
          overlayClassName="myoverlay"
          ariaHideApp={false}
          // style={customStyles}
          // contentLabel="Example Modal"
        >
        <h2 class="sgl-label-border">Update Horse</h2>
        <div>
          <form>
            <ul>
              <li className='entry_people_li'>
                <div>
                  <label className='add_entry_label_modal'>Horse name &nbsp;<em  class="required">*</em></label>
                  <div style={{clear: "both"}}></div>
                  <div  class="add_modal_div">
                    { !(this.state.horse_to_update.name == ''  ||  this.state.horse_to_update?.name_is_edited) ?
                      <span>{this.state.new_horse_data.name}</span>
                    :
                      <input type="text" name="name" value={this.state.new_horse_data.name} class="modal_input_right" id='txt_add_horse_name' onChange={evt => updateNewHorseData(evt, 'name')}/>
                    }
                    </div>
                </div>
              </li>
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                <div>
                  <div class='txt-field-container-div-modal'>
                    <label className='add_entry_label_modal'>Sex &nbsp;<em  class="required">*</em></label>
                    <div style={{clear: "both"}}></div>
                    <div  class="add_modal_div txt-field-container-modal right_padding">
                      { !(this.state.horse_to_update.sex == ''  ||  this.state.horse_to_update?.sex_is_edited) ?
                        <span>{this.state.new_horse_data.sex}</span>
                      :
                        <select className="modal_select" onChange={(e) => updateNewHorseData(e, 'sex')}  value={this.state.new_horse_data.sex}>
                          <option value="-1">Select...</option>
                          {
                              horse_genders_array.map((gender,index) => {
                              return (
                                  <option value={`${gender}`}>
                                      {gender}
                                  </option>
                              )
                              })
                          }
                        </select>
                      }

                    </div>
                  </div>
                  <div class='txt-field-container-div-modal'>
                    <div  class="txt-field-container-modal">
                        
                      <label className='add_entry_label_modal'>Color</label>
                      <div style={{clear: "both"}}></div>
                      <div class="add_modal_div txt-field-container-modal right_padding">
                        { !(this.state.horse_to_update.color == '' ||  this.state.horse_to_update?.color_is_edited) ?
                          <span>{this.state.new_horse_data.color}</span>
                        :
                          <input type="text" name='color' id="txt_add_horse_color" class="modal_input_right"  value={this.state.new_horse_data.color} onChange={evt => updateNewHorseData(evt, 'color')}/>
                        }
                        </div>
                        
                    </div>
                  </div>
                  
                </div>
              </li>
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                <div class="add_modal_div" >
                  <div  class='txt-field-container-div-modal'>
                    <label className='add_entry_label_modal'>Height &nbsp;<em  class="required">*</em></label>
                    <div style={{clear: "both"}}></div>
                    <div class="txt-field-container-modal right_padding">
                      { !(this.state.horse_to_update.height == '' ||  this.state.horse_to_update?.height_is_edited) ?
                          <span>{this.state.new_horse_data.height}</span>
                        :
                          <input type="text" name="height" id='txt_add_horse_height' class="modal_input"  value={this.state.new_horse_data.height} onChange={evt => updateNewHorseData(evt, 'height')}/>
                      }
                    </div>
                  </div>
                  <div class='txt-field-container-div-modal'>
                    <div class="add_modal_div txt-field-container-modal">
                        
                      <label className='add_entry_label_modal'>Age</label>
                      <div style={{clear: "both"}}></div>
                      <div class="input-box txt-field-container-modal right_padding">
                      { !(this.state.horse_to_update.age == ''  ||  this.state.horse_to_update?.age_is_edited) ?
                          <span>{this.state.new_horse_data.age}</span>
                        :
                          <input  type="text" name="age" id="txt_add_horse_age" class="modal_input_right"  value={this.state.new_horse_data.age} onChange={evt => updateNewHorseData(evt, 'age')}/>
                      }
                    </div>
                        
                    </div>
                  </div>
                  
                </div>
              </li>
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                  <div  class="add_modal_div">
                    <div  class='txt-field-container-div-modal'>
                      <label className='add_entry_label_modal'>Green</label>
                      <div class="txt-field-container-modal right_padding">
                        { !(this.state.horse_to_update.green == ''  ||  this.state.horse_to_update?.green_is_edited) ?
                            <p>{this.state.new_horse_data.green}</p>
                        :
                          <select className="modal_select" id='txt_add_horse_green'  value={this.state.new_horse_data.green} onChange={(e) => updateNewHorseData(e, 'green')} >
                            <option value="-1">Select...</option>
                            {
                                horse_greens_array.map((green,index) => {
                                return (
                                    <option value={`${green}`}>
                                        {green}
                                    </option>
                                )
                                })
                            }
                          </select>
                          }
                        {/* <input type="text" name="green" id='txt_add_horse_green' class="horse_name"  onChange={evt => this.updateNewHorseData(evt, 'green')}/> */}

                      </div>
                    </div>
                    <div class='txt-field-container-div-modal'>
                      <div class="add_modal_div txt-field-container-modal">
                          
                          <label className='add_entry_label_modal'>Type</label>
                          <div style={{clear: "both"}}></div>
                          <div class="input-box txt-field-container-modal right_padding">
                            { !(this.state.horse_to_update.type == ''  ||  this.state.horse_to_update?.type_is_edited) ?
                              <p>{this.state.new_horse_data.type}</p>
                            :
                              <select className="modal_select" id='txt_add_horse_green'  value={this.state.new_horse_data.type} onChange={(e) => updateNewHorseData(e, 'type')} >
                              <option value="-1">Select...</option>
                              {
                                  horse_types_array.map((green,index) => {
                                  return (
                                      <option value={`${green}`}>
                                          {green}
                                      </option>
                                  )
                                  })
                              }
                            </select>
                            }
                          </div>
                      </div>
                    </div>
                    
                  </div>
                </li>
              <hr style={{margin_top: '10px'}} />
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                <div>
                  <label className='add_entry_label'>MEMBERSHIPS</label>
                </div>
              </li>
              <li className='entry_people_li'>
              <div style={{clear: "both"}}></div>
                {/* // <div> */}
                  {
                    this.props.membership_organizations.map((membership_organization,index) => {
                    return (
                      <div className='add_modal_div modal-membership-div'>
                        <div style={{clear: "both"}}></div>
                        <label class='membership_label add_entry_label'>{membership_organization}</label>
                        <div className='membership_input_div'>
                          { ((this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships) && this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships) !== '' && !this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships, true)?.is_edited) ) ?
                              <>
                              
                              {                                
                                (this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships, true)?.readonly) && <span>{this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)}</span>
                              }
                              {
                                (this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships, true)?.editable) && <input  type="text" name="age" id={"txt_add_horse_membership_"+membership_organization}  value={this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)} class="modal_input" onChange={evt => updateNewHorseData(evt, membership_organization, true)}/>
                              }
                              </>:
                              <input  type="text" name="age" id={"txt_add_horse_membership_"+membership_organization}  value={this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)} class="modal_input" onChange={evt => updateNewHorseData(evt, membership_organization, true)}/>
                              
                          }                        

                        
                        </div>
                      </div>
                    )
                    })
                  }
                {/* // </div> */}
              </li>
                  <li className='entry_people_li'>
                    <div style={{clear: "both"}}></div>
                    <div id='add_horse_warning' className='required'>
                    {typeof this.state.add_horse_error_msg == 'string' ?
                      this.state.add_horse_error_msg
                      :
                      this.state.add_horse_error_msg.map((error,index) => {
                        return(
                            <>
                                {error}
                                <br/>
                            </>
                        )
                    })}
                    
                    </div>
                  </li>
      
            </ul>
          </form>
          <SaveCancelButtons/>
        </div>
        </UpdateModal>
      )
    }

    validateHorseChange = async() => {
      if(this.state.selected_horse?.horse_id == this.props.entry.horse_id){  //ignoring call on the same default horse
        this.props.changeSelection("people");
      }
      else if(this.state.on_vet_hold){
        //do nothing on vet hold
        this.setState({
          horse_select_error:"Selected horse is on vet hold.",
        })
      }
      else{
        // check if selected horse has some existing entries
        let horseHasDuplicateEntries = await this.checkHorseDuplicateEntries(this.state.selected_horse?.horse_id)
        if(horseHasDuplicateEntries){// horse has duplicate entries
          this.setState({
            horse_select_error:"The selected horse has already been entered in this show and cannot be added a second time. Please contact the show office for more information.",
          })
        } else{

        axios.post(this.sgl_webservice_validate_horse_change, {
          entry_id : this.props.entry.entry_id,
          show_id : this.props.show_data.show_id,
          horse_id : this.state.selected_horse_id,
          horse_data : this.state.selected_horse,
          customer_id : this.context.company_id
        }).then( response => {
          this.setState({
            horse_validate: response.data
          })
          //if valid than change to select people
          if(!this.state.on_vet_hold && response.data.success && !horseHasDuplicateEntries ){
            this.props.setSelectedHorse(this.state.selected_horse);  //only when continue button is clicked horse is set
            this.props.changeSelection("people");
          }
        })
        }
      }
    }


    render(){
      return(
        <div className='add_entry_horse add-entry-div' > 
            <this.UpdateHorseModal/>
            <this.LinkedHorses/>
            {
              this.state.show_search_horse ?
                <this.SearchHorseSecondary/>:
                <this.SearchHorsePrimary/>
            }

            {
              !this.state?.horse_validate?.success &&
              <div class='required'>
                    {this.state?.horse_validate?.error}
                </div>
            }
            
            {
              !this.state.show_search_horse &&
              <div class='continue-button-div'>
                <div class='required float_right'>
                    * Required Fields
                </div>
                <br class="sgl-mb-5"/>
                <button class='sgl-button float_right' onClick={() => { this.validateHorseChange() }}>
                    Continue
                </button>
              </div>
            }
            
        </div>
       )
    }
}

class SelectPeople extends React.Component{

  get sgl_webservice_edit_entry() {
    return this.context.nestApiUrl + '/entries/getEditEntry';
  }

  get sgl_webservice_save_entry() {
    return this.context.nestApiUrl + '/entries/saveEditEntry';
  }

  get sgl_webservice_shows_list() {
    return this.context.nestApiUrl + '/shows';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  get sgl_webservice_iphone() {
    return this.context.sglApiUrl + '/iphonev2/addentryv2/';
  }

  get sgl_webservice_validate_remove_rider() {
    return this.context.nestApiUrl + '/entries/validateRemoveRider';
  }

  get sgl_webservice_validate_horse_change() {
    return this.context.nestApiUrl + '/entries/validateHorseChange';
  }

  get sgl_webservice_validate_save_entry() {
    return this.context.nestApiUrl + '/entries/validateSaveEntry';
  }

  constructor(props){
    super(props);
    this.state={
      selected_rider : {},
      riders: props.selected_riders.length > 0 ? props.selected_riders : this.props.entry?.EntryRiders.map( (er) => this.findPeopleById(er.rider_id) ),
      governing_organization: this.props?.governing_organization,
      people_search_list:[],
      people_search_by_txt_label: 'Enter USEF No.',
      people_search_org:'by_usef',
      people_search_type: 'by_name',
      people_search_label_th: "USEF No.",
      people_search_field: '',
      people_search_field_text: '',
      txt_people_name_disabled:false,
      txt_people_membership_no_disabled:true,
      people_first_name: '',
      people_last_name: '',
      people_membership_no: '',

      people_search_label_secondary:' by USEF No.',
      selected_search_person:{},
      searching_for:"",
      show_people_search:false,

      person_to_update: {},
      selected_trainer: props.selected_trainer?.people_id ? props.selected_trainer : this.findPeopleById(this.props.entry?.trainer_id),
      selected_owner: props.selected_owner?.people_id ? props.selected_owner : this.findPeopleById(this.props.entry?.entryowner_id),
      selected_prize: props.selected_prize?.people_id ? props.selected_prize : this.findPeopleById(this.props.entry?.prizemoneyrecipient_id),
      selected_responsible: props.selected_responsible?.people_id ? props.selected_responsible : this.findPeopleById(this.props.entry?.responsibleparty_id),
      selected_ec_responsible: props.selected_ec_responsible?.people_id ? props.selected_ec_responsible : this.findPeopleById(this.props.entry?.ec_responsibleparty_id),
      people_selection_error_msg: '',

      is_open_people_modal: false,
      update_people_error_msg: '',
      person_to_update_default: {},
      
      error_riders_list:[],
      people_validate_error:"",
      people_search_loading:false,
      loading_parents:false,
    }
  }
  

  getPeopleMembershipNumber(person, gov_org){
      
    var membership_no = '';
    if (person && person.memberships && person.memberships.length > 0) {
      person.memberships.forEach(membership => {
        if(membership.organization_code == gov_org && membership.membership_number != ''){
          membership_no = membership.membership_number;
        }
      });

      // membership_no = person.memberships[0].membership_number;
    }
    if (membership_no == ''){
      membership_no = 'N/A';
    }
    return membership_no;
  }    
  
  getHasMissingInfo(object, mandatory_fields){
    var has_missing_info = false;
    mandatory_fields.forEach(field => {
      if(!object[field] || object[field] == ''){
        has_missing_info = true;
      }
    });
    return has_missing_info;
  }

  getMembershipWarning(memberships = []){
    var membership_warning = false;
    memberships.forEach(membership => {
      if(!membership.membership_number || membership.membership_number == ''){
        membership_warning = true;
      }
    });
    return membership_warning;
  }

  getPeopleUpdateMsg(person, area){
    var required_fields = ["first", "last_name", "address", "city", "state", "postal_code", "country", "email_address", "mobile_phone"];

    if(person.isfarmrto){
      required_fields = ["company_name", "address", "city", "state", "postal_code", "country", "email_address", "mobile_phone"];
    }
    if(area == 'rider'){
      if (person.on_medical_hold){
        return <p style={{color: "red"}}><img src={warning_red} class='warning-icon'/> {person.fl_name} is on medical hold. Cannot be added to this entry.</p>;
      }
    //   if ( person.is_junior && (!person.parent_guardian_id || person.parent_guardian_id == 0)) {
    //   return (
    //     <p style={{ color: "red" }}>
    //       <img src={warning_red} className='warning-icon' />{" "}
    //       Please select a Parent/Guardian for junior rider {person.fl_name}.
    //     </p>
    //   );
    // }
    } 
    if(area == 'responsible'){
       if (person.on_credit_hold){
        return <p style={{color: "red"}}><img src={warning_red} class='warning-icon'/> {person.fl_name} is on credit hold. Cannot be added to this entry.</p>;
      }
    }
    if (this.getMembershipWarning(person.memberships)){
      return 'Click here to add this membership.';
    } else if (this.getHasMissingInfo(person, required_fields)){
      return 'There is some missing information on file. Click here to update this person.';
    }  else {
      return 'Click here to update this person.';
    }
  }

  openUpdatePeopleModel = (person, field) => (e) => { 

    this.setState({
      is_open_people_modal: true,
      update_people_error_msg: ' ',
      person_to_update: person,
      person_to_update_default : JSON.parse(JSON.stringify(person)),
      // JSON.parse(JSON.stringify(person)),
      updating_person_field: field
    });
    
  }

  findPeopleById(people_id){
    const people = this.props.people_list.find( p => p.people_id == people_id)
    return people;
  }

  async onPersonSelect(e, section_name, rider_index = -1){
    if(e.target.value == '-4') return;

    if(section_name == 'rider'){
      const targetValue = e.target.value;

      //already exists in current riders selected
      const alreadyExists = this.state.riders.find((rider)=> rider.people_id == targetValue)
      if(alreadyExists){
        this.state.riders[rider_index].remove_error = "Rider Already Exists in Selected Riders."
      }
      else{
        let validateRemoveRider = true;

        const isInEntryRiders = this.props.entry.EntryRiders.find((er)=> er.rider_id == this.state.riders[rider_index]?.people_id)
        //validate on empty object and on changing preselected riders
        if(this.state.riders[rider_index]?.people_id && isInEntryRiders){
          validateRemoveRider = await this.validateRemoveRider(this.state.riders[rider_index])
        }
        if(validateRemoveRider){
          const rider = this.findPeopleById(targetValue);
          this.state.riders[rider_index] = rider;
          this.setState({ riders: this.state.riders });
          if (rider.is_junior) {
             this.setState({ loading_parents: true });
            const res = await this.props.getLinkedParents(rider.people_id, this.context.company_id);
            const { linked_people = [], pending_linked_people = [] } = res.data || {};
            const allParents = [...linked_people, ...pending_linked_people];
            const primaryParent = allParents.find(p => p.is_primary == 1) || {};
            rider.parents_list = allParents;
            rider.parent_guardian_id = primaryParent.people_id ?? 0;
            this.setState({ loading_parents: false });
          }
          this.state.riders[rider_index] = rider;
        }
      }
      // const updatedRiders = [...this.state.riders];
      // this.setState({ riders: updatedRiders });
      this.setState({
        riders:this.state.riders
      })
    }

    else if(section_name == 'trainer'){
      const trainer = this.findPeopleById(e.target.value);
      this.setState({
        selected_trainer:trainer
      })
    }

    else if(section_name == 'owner'){
      const owner = this.findPeopleById(e.target.value);
      this.setState({
        selected_owner:owner
      })
    }

    else if(section_name == 'prize'){
      const prize = this.findPeopleById(e.target.value);
      this.setState({
        selected_prize:prize
      })
    }

    else if(section_name == 'responsible'){
      const responsible = this.findPeopleById(e.target.value);
      this.setState({
        selected_responsible:responsible
      })
    }

    else if(section_name == 'ec_responsible'){
      const ec_responsible = this.findPeopleById(e.target.value);
      this.setState({
        selected_ec_responsible:ec_responsible
      })
    }
    
    else if(section_name == 'parent'){
      let rider = this.state.riders[rider_index];
      
      if(!rider) return;

      if (!Array.isArray(rider.parents_list)) {
        rider.parents_list = [];
      }

      const parent = this.findPeopleById(e.target.value);
      const formattedParent = {
        ...parent,
        name: parent.name || parent.fl_name || parent.lf_name,
        status: 'pending',
      };
      rider.parents_list.push(formattedParent);
      rider.parent_guardian_id = formattedParent.people_id;

      this.state.riders[rider_index] = rider;
      this.setState({ riders: this.state.riders });
    }
  }

  async validateRemoveRider(rider){
    let valid= true;
    const response = await axios.get(this.sgl_webservice_validate_remove_rider,{
      params:{
        show_id: this.props.show_data.show_id,
        entry_id: this.props.entry.entry_id,
        rider_id: rider.people_id,
        customer_id: this.context.company_id
      }
    })

    if(response?.data?.success){
      valid = true;
    }

    else{
      valid = false;
      rider.remove_error = response?.data?.error
      this.setState({
        riders: this.state.riders
      })
    }



    return valid;
  }

  async removeRider(index){
    const rider = this.state.riders[index];
    let canRemove = true;

    const isInEntryRiders = this.props.entry.EntryRiders.find((er)=> er.rider_id == this.state.riders[index]?.people_id)

    if(rider?.people_id || isInEntryRiders){ //if people is not empty
      canRemove = await this.validateRemoveRider(rider);
    }

    if(canRemove){
      this.state.riders.splice(index,1)
    }

    this.setState({
      riders: this.state.riders
    })

    // return this.state.riders[index]?.remove_error ? false : true;
  }

  addRider(){
    this.state.riders.push({ })
    this.setState({
      riders: this.state.riders
    })
  }

  async showPeopleSearch(searching_for){
    const field = searching_for.split(",")[0];
    let canSearch = true;

    //validate if the current rider can be changed to show people search
    if(field == 'rider'){
      const index = searching_for.split(",")[1];
      const rider = this.state.riders[index]

      if(rider?.people_id){ //if people is not empty
        canSearch = await this.validateRemoveRider(rider);
      }
    }

    if(canSearch){
      this.setState({
        searching_for:searching_for,
        show_people_search:true,
        people_search_field: field,
      })
    }
  }

  findCountry(selected_country) {
    return countries_array.find((current_country) => {
      return selected_country.toLowerCase() == current_country.toLowerCase();
    });
  }    

  getMembershipNumberToUpdate(org, memberships_list = [], object = false){
    const membership = memberships_list.find(mem => mem.organization_code === org);
    if (membership){
      if(object) return membership;
      
      return membership.membership_number;
    }
    return;
  }

  SearchPeople = () => {

    const setPeopleLabelTh = () =>{
      var organization_label = this.state.governing_organization;
      if(this.state.people_search_type == 'by_name'){
        if(this.state.governing_organization == "EC"){
            organization_label = "Sport License";
        }else if(this.state.governing_organization == "USEF"){
            organization_label = "USEF";
        }
        organization_label = organization_label + " No.";
      } else {
        organization_label = 'USEF No.';
        if (this.state.people_search_org == 'by_ec'){
          organization_label = 'Sport License No.';
        } else if (this.state.people_search_org == 'by_fei'){
          organization_label = 'FEI No.';
        }
      }
      this.setState({
        people_search_label_th: organization_label
      })
    }

    const getPeopleSearchData = (search_by, search_term) => {
      if(search_term && search_term.trim() != ''){
        //show indicator icon on search
        this.setState({
          people_search_loading: true
        })

        axios.get(this.sgl_webservice_iphone+'SearchPerson',{
          params : {
              search_by : search_by,
              search_term : search_term.trim(),
              company_id: this.context.company_id
          }
        }).then(results => {
          //indicator search
          setPeopleLabelTh();
          this.setState({
            people_search_list: results.data.people,
            people_search_loading: false
          })    
        })
      } else {
        this.setState({
          people_search_list: [],
        });
      }
      
    }

    const peopleSearch = () => {
      
      if (this.state.people_search_type == 'by_name') {
          var name = this.state.people_first_name + ' ' + this.state.people_last_name;
           getPeopleSearchData(this.state.people_search_type, name);
      } else {
          getPeopleSearchData(this.state.people_search_org, this.state.people_membership_no);
      }
      // document.getElementById('add_people_button').style.display = "inline";
    }

    const setPeopleSearchOrg = (event) => {
      var people_search_label_secondary = 'by USEF No.';
      var people_search_by_txt_label = 'Enter USEF No.';
      if (event.target.value == 'by_ec'){
        people_search_label_secondary = 'by Passport No.';
        people_search_by_txt_label = 'Enter Passport No.';
      } else if (event.target.value == 'by_fei'){
        people_search_label_secondary = 'by FEI No.';
        people_search_by_txt_label = 'Enter FEI No.';
      }
      this.setState({
          people_search_org : event.target.value,
          people_search_label_secondary: people_search_label_secondary,
          people_search_by_txt_label: people_search_by_txt_label
      });

    }

    const setPeopleSearchType = (event) => {
      var membership_disabled = false;
      var people_disabled = true;

      if (event.target.value === 'by_name'){
        people_disabled = false;
        membership_disabled = true;
      }
      this.setState({
          people_search_type : event.target.value,
          txt_people_membership_no_disabled: membership_disabled,
          txt_people_name_disabled: people_disabled
      });

    }

    const updateFirstName = (evt) => {
      this.setState({
        people_first_name: evt.target.value
      });
    }

    const updateLastName = (evt) => {
      this.setState({
        people_last_name: evt.target.value
      });
    }

    const _handlePeopleSearchKeyPress = (e) => {
      if (e.key === 'Enter') {
        peopleSearch();
      }
    }
    const updatePeopleMembership = (evt) => {
      this.setState({
        people_membership_no: evt.target.value
      });
    }

    const setPerson = (event) => {
      const person = this.state.people_search_list.find(el => el.people_id === event.currentTarget.value);
      
      // this.setPersonState(person, this.state.people_search_field);
      this.setState({
        selected_search_person : person,
      });

    }

    const getPersonUsefNo = (person) => {
      var usef_no = '';
      if(this.state.governing_organization=="EC"){
        usef_no = person["ec_sln"];
      }
      else if(this.state.governing_organization=="FEI"){
        usef_no = person["fei_id"];
      }
      else{
        usef_no = person["usef_number_ahsa_number"];
      }

      return usef_no;
    }

    const getPersonName = (person) => {
      // var name = person.fl_name
      console.log("inside get person name",person)
      console.log("state people search field is",this.state.people_search_field)
      if (this.state.people_search_field == 'Rider' || this.state.people_search_field == 'rider2' || this.state.people_search_field == 'rider3'){
        if (person.on_medical_hold){
          return '\n [On Medical Hold.]';
        }
      }
      if (this.state.people_search_field == 'responsible'){
        if (person.on_credit_hold){
          return '\n [On Credit Hold.]';
        } 
      }
      if (this.state.governing_organization=='EC' && person.ec_suspended) {
        return '\n [Not In Good Standing.]';
      }
      if(this.state.people_search_field === 'parent' || this.state.people_search_field === 'Parent2' || this.state.people_search_field === 'Parent3'){
        if (person.is_junior) {
          return '\n [Junior Rider.]';
        }
        if (!person.email_address) {
          return '\n [No Email Address.]';
        }
      }

      return null;
    }

    const cancel_people_search = () => (e) => {
      this.setState({
        show_people_search:false
      })
    }

    const person_selected = () => (e) => {
      if(!this.state.selected_search_person?.people_id){  //if no person is selected from search on continue button
        return;
      }

      const searching_for = this.state.searching_for.split(",")[0]

      if(searching_for == 'rider'){
        const index = this.state.searching_for.split(",")[1];
        this.state.riders[index] = this.state.selected_search_person;
        this.setState({
          riders:this.state.riders,
        })
      }
      else if (searching_for == 'trainer'){
        this.setState({
          selected_trainer:this.state.selected_search_person
        })
      }
      else if (searching_for == 'owner'){
        this.setState({
          selected_owner:this.state.selected_search_person
        })
      }
      else if (searching_for == 'prize'){
        this.setState({
          selected_prize:this.state.selected_search_person
        })
      }
      else if(searching_for == 'responsible'){
        this.setState({
          selected_responsible:this.state.selected_search_person
        })
      }
      else if(searching_for == 'ec_responsible'){
        this.setState({
          selected_ec_responsible:this.state.selected_search_person
        })
      }
      else if (searching_for == 'parent') {
        const rider_index = this.state.searching_for.split(",")[1];
        let rider = this.state.riders[rider_index];
        if(!rider) return;

        if (!Array.isArray(rider.parents_list)) {
          rider.parents_list = [];
        }
        const parent = this.state.selected_search_person;
        const formattedParent = {
          ...parent,
          name: parent.name || parent.fl_name || parent.lf_name,
          status: 'pending',
        };
        rider.parents_list.push(formattedParent);
        rider.parent_guardian_id = formattedParent.people_id;

        this.state.riders[rider_index] = rider;
        this.setState({ riders: this.state.riders });
      }
      if(this.findPeopleById(this.state.selected_search_person.people_id)?.people_id){
        //already exists
      }
      else {
        this.props.people_list.push(this.state.selected_search_person);
      }

      this.setState({
        people_search_list: [],
        selected_search_person: {},
        // people_search_by_txt_label: 'Enter USEF No.',
        // people_search_org:'by_usef',
        people_search_type: 'by_name',
        txt_people_name_disabled:false,
        txt_people_membership_no_disabled:true,
        people_first_name: '',
        people_last_name: '',
        people_membership_no: '',
        show_people_search:false,
      })

    }


    return(
      <div id='search_people' className='add_entry_horse add-entry-div'> 
        <ul>
        <li className='entry_people_li'>
          <div>

              <label className='add_entry_label'>Governing Organization</label>
              <div style={{clear: "both"}}></div>
              <input type="radio" id='ppl_by_usef' name="people_search_org" class="sgl-mr-5"
                  value='by_usef' onChange={setPeopleSearchOrg}
                  checked={this.state.people_search_org === 'by_usef'} 
              />
              <label for='ppl_by_usef' className='add_entry_custom_label'>  United States Equestrian Federation (USEF)</label>
              <br/>
              <input type="radio"  id='ppl_by_ec' name="people_search_org" class="sgl-mr-5"
                  value='by_ec' onChange={setPeopleSearchOrg}
                  checked={this.state.people_search_org === 'by_ec'} 
              />
              <label for='ppl_by_ec' className='add_entry_custom_label'>  Equine Canada (EC)</label>

              <br/>
              <input type="radio" id='ppl_by_fei' name="people_search_org" class="sgl-mr-5"
                  value='by_fei' onChange={setPeopleSearchOrg}
                  checked={this.state.people_search_org === 'by_fei'} 
              />
              <label for='ppl_by_fei' className='add_entry_custom_label'>  Federation Equestre Internationale (FEI)</label>
          </div>
        </li>
        <li className='entry_people_li'>
          <div>

              <label className='add_entry_label'>Search for a {(this.state.governing_organization == 'EC' && this.state.people_search_field_text == 'Trainer')? 'Coach':this.state.people_search_field_text}:</label>
              <div style={{clear: "both"}}></div>
              <input type="radio" id='ppl_by_name' name="people_search_type" class="sgl-mr-5"
                  value='by_name' onChange={setPeopleSearchType}
                  checked={this.state.people_search_type === 'by_name'} 
              />
              <label for='ppl_by_name' className='add_entry_custom_label'>  by Name</label>
              
              <br/>
              <input type="radio" id='ppl_by_gvrn' name="people_search_type" class="sgl-mr-5"
                  value='by_govrn' onChange={setPeopleSearchType}
                  checked={this.state.people_search_type === 'by_govrn'} 
              />
              <label for='ppl_by_gvrn' className='add_entry_custom_label'>  {this.state.people_search_label_secondary}</label>

          </div>
        </li>
        <li className='entry_people_li'>
          <div>
            <div style={{clear: "both"}}></div>
            <div class="txt-field-container-div mb-10">
              <label className='add_entry_label'>First Name</label>
              <div class="people_selection_div txt-field-container">
                <input style={{backgroundColor: this.state.txt_people_name_disabled ? '#D3D3D3' : 'transparent'}} 
                  type="text" name="name" id='txt_people_first_name' class="input-height horse_name"
                  value={this.state.people_first_name}
                  disabled={this.state.txt_people_name_disabled}
                  onChange={evt => updateFirstName(evt)}
                  onKeyPress={evt => _handlePeopleSearchKeyPress(evt)}
                />

              </div>
            </div>
            <div class="txt-field-container-div">
                  
              <label className='add_entry_label'>Last Name</label>
              <div style={{clear: "both"}}></div>
              <div class="input-box txt-field-container">
                <input class="input-height" style={{backgroundColor: this.state.txt_people_name_disabled ? '#D3D3D3' : 'transparent'}}
                  type="text" name="txt_people_last_name" 
                  value={this.state.people_last_name}
                  disabled={this.state.txt_people_name_disabled}
                  onChange={evt => updateLastName(evt)}
                  onKeyPress={evt => _handlePeopleSearchKeyPress(evt)} 
                />
                  
              </div>
                  
            </div>
          </div>
        </li>
        <li className='entry_people_li'>
          <div>
            <div style={{clear: "both"}}></div>
              <div class="txt-field-container-div">
                <label className='add_entry_label'>{this.state.people_search_by_txt_label}</label>
                <div class="people_selection_div txt-field-container">
                <input class="input-height" style={{backgroundColor: this.state.txt_people_membership_no_disabled ? '#D3D3D3' : 'transparent'}} 
                  type="text" name="txt_people_membership_no" 
                  value={this.state.people_membership_no}
                  disabled={this.state.txt_people_membership_no_disabled}
                  onChange={evt => updatePeopleMembership(evt)}
                  onKeyPress={evt => _handlePeopleSearchKeyPress(evt)} 
                />

                </div>
              </div>
              <div class="people_search_wrapper">                    
                  <button class='sgl-mb-5 mt-20 horse_search-button sgl-button' onClick={()=>{peopleSearch();}}>
                    Search
                  </button>
                  {
                    this.state.people_search_loading &&
                    <span id="search-people-please-wait" class='vertical-align-middle'><img src={indicator_icon} /></span>
                  }
              </div>
            </div>
        </li>
        <li className='entry_people_li'>
          <div class="" style={{clear: "both"}}>
          <table className="table table-striped table-hover scroll_table">
            <thead class="classes-header">                    
              <tr class="sgl-primary-header">
                <th style={{min_width: '20px', width: '40px'}}>*</th>
                <th class="display_on_mobile"></th>
                {/* <th class="display_on_desktop">{this.getPeopleLabelTh()}</th> */}
                <th class="display_on_desktop">{this.state.people_search_label_th}</th>
                <th class="display_on_desktop">Name</th>
                <th class="display_on_desktop">Type</th>
                <th class="display_on_desktop">State</th>
                <th class="status_icon display_on_desktop" style={{ width: '70px'}}><img src={red_dot} class="placing-icon"/><img src={green_dot} class="placing-icon"/></th>
              </tr>
            </thead>
            <tbody className="table-scroll">
            { 
              this.state.people_search_list?.map((data, index) => {
                var disable_person = (((this.state.people_search_field === 'Rider' || this.state.people_search_field === 'rider2' || this.state.people_search_field === 'rider3') && (data.on_medical_hold || data.isfarmrto)) || ( this.state.people_search_field === 'Trainer' && data.isfarmrto) || ( this.state.people_search_field === 'responsible' && data.on_credit_hold) || ((this.state.people_search_field === 'parent' || this.state.people_search_field === 'Parent2' || this.state.people_search_field === 'Parent3') && (data.is_junior || !data.email_address))) ? true : false;
                var rto_ec_suspended = (this.state.governing_organization=='EC' && data.ec_suspended)
                let rto_suspended = (this.state.governing_organization=='EC' && data.ec_suspended) || (this.state.governing_organization=='USEF' && data.usef_suspended != '0') || (this.state.governing_organization=='FEI' && data.fei_suspended);
                return (
                  <tr class="sgl-anchor">
                    <td style={{min_width: '20px', width: '40px'}} nowrap="nowrap">
                        <input type="radio" name="person_select" 
                            value={data.people_id} 
                            checked={this.state.selected_search_person.people_id === data.people_id} 
                            // onChange={(e) => this.onHorseChange(e)}
                            onChange={setPerson}
                            disabled = {(disable_person || rto_ec_suspended) ? true : false}
                        />
                    </td>
                    {/* onClick={(data.on_medical_hold || data.on_credit_hold)? undefined : () => this.setShow */}
                    <td class="display_on_mobile mbl_custom_row new-line" onClick={(disable_person || rto_ec_suspended)? undefined : () => setPerson({currentTarget: {value: data.people_id}})}>
                      <p class="table_row_p">
                        <span><strong>{this.state.people_search_label_th} </strong>{getPersonUsefNo(data)}</span>
                        <span class="status_icon"><img src={rto_suspended ? red_dot: green_dot} class="placing-icon"/></span>
                        <br></br>
                        <span><strong>Name: </strong>{data.fl_name}<text class='required'>{getPersonName(data)}</text></span>
                        <br></br>
                        <span><strong>State: </strong>{data.state}</span>
                        <span class="status_icon"><strong>Type: </strong>{data.isfarmrto?'F':'I'}</span>
                      </p>
                    </td>
                    <td class="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => setPerson({currentTarget: {value: data.people_id}})}>{getPersonUsefNo(data)} </td>
                    <td class="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => setPerson({currentTarget: {value: data.people_id}})}>{data.fl_name}<text class='required'>{getPersonName(data)}</text></td>
                    <td class="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => setPerson({currentTarget: {value: data.people_id}})}>{data.isfarmrto?'F':'I'}</td>
                    <td class="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => setPerson({currentTarget: {value: data.people_id}})}>{data.state}</td>
                    <td class="new-line status_icon display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})} style={{width: '40px'}}><img src={rto_suspended ? red_dot: green_dot} class="placing-icon"/></td>
                  </tr>
                )
              })
            }
            </tbody>
          </table>
          </div>
        </li>
        </ul>

        <div class='continue-button-div'>
          <span class="color-gray"><img src={red_dot} class="placing-icon"/> indicates that the USEF / EC / FEI Membership has been suspended.</span>
          <br/>
          <span class="color-gray"><img src={green_dot} class="placing-icon"/> indicates that the USEF / EC / FEI Membership is active.</span>
          <div class='required float_right'>
            * Required Fields
          </div>
          <br class="sgl-mb-5"/>
          <button class='sgl-button float_right horse_search-button' onClick={person_selected()}>
            Continue
          </button>
          <button class='sgl-button float_right horse_search-button' onClick={cancel_people_search()}>
            Cancel
          </button>
        </div>
      </div>
    )
  }

  PeopleUpdateModal = () => {
    
    const afterOpenModal = () => {
      // references are now sync'd and can be accessed.
      // this.subtitle.style.color = '#f00';
      
    }

    const isMembershipEditable = (field_name) => {
      let memberships_list = this.state.person_to_update['memberships'];
      const membership = memberships_list.find(mem => mem.organization_code === field_name);
      return membership?.is_edited ? true: false;
    }

    const updatePersonData = (evt, field_name, is_membership = false) => {
      if (is_membership){
        let memberships_list = this.state.person_to_update['memberships'];

        let membership = {
          'organization_code': field_name,
          'membership_number': evt.target.value,
          'is_edited': true
        }
        const i = memberships_list.findIndex(mem => mem.organization_code === field_name);
        if (i > -1) {
          memberships_list[i] = membership; // (2)
        } else {
          memberships_list.push(membership);
        }
        this.setState({
          person_to_update:this.state.person_to_update
        })
      }
      else{
        
        this.state.person_to_update[field_name] = evt.target.value;
        this.state.person_to_update[field_name+"_is_edited"] = true;
        this.setState({
          person_to_update:this.state.person_to_update
        })
      }
      
    }

    const ValidatePerson = (person_data) => {
      axios.get(this.sgl_webservice_iphone+'ValidatePerson',{
        params : {
            person : person_data,
            company_id: this.context.company_id
        }
      }).then(results => {
        handleValidatePersonResponse(results.data);
   
      })
      
    }

    const handleValidatePersonResponse = (response_data) => {
      if (response_data.success) {
        // update memberships
        if( typeof response_data.memberships.EC !== 'undefined') {
          let membership_number = response_data.memberships.EC[0].membership.membership_number;
          let evt = {
            'target':{
              'value':membership_number
            }
          };
          updatePersonData(evt,'EC',true);
        }
        if( typeof response_data.memberships.OHJA !== 'undefined') {
          let membership_number = response_data.memberships.OHJA[0].membership.membership_number;
          let evt = {
            'target':{
              'value':membership_number
            }
          };
          updatePersonData(evt,'OHJA',true);
        }

        this.state.person_to_update.is_updated = true;

        this.setState({
          is_open_people_modal: false,
          update_people_error_msg: '',
          updating_person_field: '',
          person_to_update: {}
          // new_person_data: new_person_data_initial
        }); 
      } else {
        this.setState({update_people_error_msg: response_data.errors}); 
      }
    }

    const updatePerson = () => {
      var error_msg = '';
      var lf_name = '';
      var fl_name = '';
      if (this.state.person_to_update.isfarmrto){
        lf_name = this.state.person_to_update.company_name;
        fl_name = this.state.person_to_update.company_name;
        if (this.state.person_to_update.company_name == '') {
          error_msg = 'Please enter Company Name';
        }
      } else {
        lf_name = this.state.person_to_update.last_name + ', ' + this.state.person_to_update.first;
        fl_name = this.state.person_to_update.first + ' ' + this.state.person_to_update.last_name;

        if (this.state.person_to_update.first == '') {
          error_msg = 'Please enter First Name';
        } else if (this.state.person_to_update.last_name == '') {
          error_msg = 'Please enter Last Name';
        }
      }
      if (error_msg == ''){
        if (this.state.person_to_update.address == '') {
          error_msg = 'Please enter Address';
        } else if (this.state.person_to_update.city == ''){
          error_msg = 'Please enter City';
        } else if(this.state.person_to_update.state == '') {
          error_msg = 'Please enter State';
        } else if(this.state.person_to_update.postal_code == '') {
          error_msg = 'Please enter Postal Code';
        } else if(this.state.person_to_update.country == '') {
          error_msg = 'Please enter your Country';
        } else if(this.state.person_to_update.email_address == '') {
          error_msg = 'Please enter an Email Address';
        } else if(this.state.person_to_update.mobile_phone == '') {
          error_msg = 'Please enter Mobile number';
        }
      }

      this.state.person_to_update.lf_name = lf_name;
      this.state.person_to_update.fl_name = fl_name;

      if (error_msg == ''){
        var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(this.state.person_to_update))));
        ValidatePerson(encoded_data);

        
      } else {
        this.setState({update_people_error_msg: error_msg}); 
      }
    }

    const closePeopleModal = () => {
      if(this.state.update_people_error_msg != ""){
        
        //replace in array in people list
        const index = this.props.people_list.findIndex( (people) => people?.people_id == this.state.person_to_update?.people_id )
        this.state.person_to_update = this.state.person_to_update_default 
        Object.assign(this.props.people_list[index] ,  this.state.person_to_update) 

        this.setState({
          person_to_update: this.state.person_to_update,
          is_open_people_modal: false,
          person_to_update_default: {},
          update_people_error_msg: ' ',
        })

        switch(this.state.updating_person_field){
          case "owner":
            this.setState({
              selected_owner: this.props.people_list[index]
            })
            break;
          case "trainer":
            this.setState({
              selected_trainer: this.props.people_list[index]
            })
            break;
          case "prize":
            this.setState({
              selected_prize: this.props.people_list[index]
            })
            break;
          case "responsible":
            this.setState({
              selected_responsible: this.props.people_list[index]
            })
            break;
          case "ec_responsible":
            this.setState({
              selected_ec_responsible: this.props.people_list[index]
            })
            break;
          default:
            this.setState({
              riders: this.state.riders.map( (er) => this.findPeopleById(er.people_id) )
            })
            break;
        }
      }
      // this.getPeopleList();
     else{
      this.setState({
        is_open_people_modal: false,
        // new_person_data: JSON.parse(JSON.stringify(new_person_data_initial)),
        person_to_update: {},
        updating_person_field: '',
        update_people_error_msg :' '
      });
     }
      
    }
    
    if(!this.state.is_open_people_modal){
      return(null);
    }
    

    return(
      <UpdateModal
        isOpen={this.state.is_open_people_modal}
        onAfterOpen={afterOpenModal}
        onRequestClose={closePeopleModal}
        className="mymodal modal-width-responsive"
        overlayClassName="myoverlay"
        ariaHideApp={false}
        // style={customStyles}
        // contentLabel="Example Modal"
      >
        <h2>Update Person</h2>
        <div>
          <form>
            <ul>
              <li  className='entry_people_li'>
                
                {
                  this.state.person_to_update?.isfarmrto ?

                <div className='my-row' id='add_people_company_div'>
                  <div class = 'input-group-full'>
                    <label className='add_entry_label_modal'>Company name &nbsp;<em  class="required">*</em></label>
                    <div style={{clear: "both"}}></div>
                    <div  class="add_modal_div right_padding">
                      { (this.state.person_to_update?.company_name !== '' || !this.state.person_to_update?.company_name_is_edited) ?
                        <span>{this.state.person_to_update?.company_name}</span>
                      :
                        <input type="text" name="companyname" class="modal_input_right" id='txt_add_people_company_name' value={this.state.person_to_update.company_name} onChange={evt =>updatePersonData(evt, 'company_name')}/>
                      }
                    </div>
                  </div>
                </div>
                :
                <div className="add_modal_div my-row" id='add_people_name_div'>
                  <div class='input-group'>
                    <label className='add_entry_label_modal'>First Name &nbsp;<em  class="required">*</em></label>
                    <div style={{clear: "both"}}></div>
                    <div class="txt-field-container-modal right_padding">
                      { ( this.state.person_to_update.first !== '' || this.state.person_to_update.first_is_edited )  ?
                        <span>{this.state.person_to_update.first}</span>
                      :
                        <input type="text" name="first_name" id='txt_add_people_first_name' class="modal_input_half"  value={this.state.person_to_update.first} onChange={evt => updatePersonData(evt, 'first')}/>
                      }
                    </div>
                  </div>
                  <div class='input-group'>
                    <div  class="add_modal_div">
                        
                            <label className='add_entry_label_modal'>Last Name &nbsp;<em  class="required">*</em></label>
                            <div style={{clear: "both"}}></div>
                            <div class="input-box txt-field-container-modal right_padding">
                              { (this.state.person_to_update.last_name !== '' || !this.state.person_to_update.last_name_is_edited) ?
                                <span>{this.state.person_to_update.last_name}</span>
                              :
                                <input  type="text" name="last_name" id="txt_add_people_last_name" class="modal_input_half" value={this.state.person_to_update.last_name} onChange={evt => updatePersonData (evt, 'last_name')}/>
                              }
                            </div>
                        
                    </div>
                  </div>
                </div>
                }
              </li>
              <li className='entry_people_li'>
                <div class="my-row">
                  <div class = 'input-group-full'>
                    <label className='add_entry_label_modal'>Address &nbsp;<em  class="required">*</em></label>
                    <div style={{clear: "both"}}></div>
                    <div  class="add_modal_div right_padding">
                      { ( this.state.person_to_update?.address == '' || this.state.person_to_update.people_id == this.props.people_id || this.state.person_to_update.address_is_edited) ?
                          <input style={{width: "95% !important"}} type="text" name="address" class="modal_input_right" id='txt_add_people_address' value={this.state.person_to_update?.address} onChange={evt => updatePersonData(evt, 'address')}/>

                        :
                        <span> XXXXXXXXXXXXXXXXXXXXXXXXXXXX </span>

                      }
                    </div>
                  </div>
                </div>
              </li>
              <li className='entry_people_li'>
                  <div class="add_modal_div  my-row">
                    <div class='input-group'>
                      <label className='add_entry_label_modal'>City &nbsp;<em  class="required">*</em></label>
                      <div style={{clear: "both"}}></div>
                      <div class="txt-field-container-modal right_padding">
                        { (this.state.person_to_update.city == '' || this.state.person_to_update.people_id == this.props.people_id || this.state.person_to_update.city_is_edited ) ?
                          <input type="text" name="city" id='txt_add_people_city' class="modal_input_half" value={this.state.person_to_update.city}  onChange={evt => updatePersonData(evt, 'city')}/>

                        :
                          <span> XXXXXXXXXXXXXXX </span>

                        }

                      </div>
                    </div>
                    <div class=' input-group'>
                      <div  class="add_modal_div txt-field-container-modal">
                          
                              <label className='add_entry_label_modal'>State &nbsp;<em  class="required">*</em></label>
                              <div style={{clear: "both"}}></div>
                              <div class="input-box txt-field-container-modal right_padding">
                                { (this.state.person_to_update.state == '' || this.state.person_to_update.people_id == this.props.people_id  || this.state.person_to_update.state_is_edited ) ?
                                  <input  type="text" name="state" id="txt_add_people_state" class="modal_input_half" value={this.state.person_to_update.state} onChange={evt => updatePersonData (evt, 'state')}/>

                                :
                                  <span> XX </span>

                                }
                              </div>
                          
                      </div>
                    </div>
                    
                  </div>
              </li>
              <li className='entry_people_li'>
                  <div class="add_modal_div my-row">
                    <div class='input-group'>
                      <label className='add_entry_label_modal'>Postal Code &nbsp;<em  class="required">*</em></label>
                      <div style={{clear: "both"}}></div>
                      <div class="txt-field-container-modal right_padding">
                        { (this.state.person_to_update.postal_code == '' || this.state.person_to_update.people_id == this.props.people_id || this.state.person_to_update.postal_code_is_edited ) ?
                          <input type="text" name="postal_code" id='txt_add_people_postal_code' class="modal_input_half"  value={this.state.person_to_update.postal_code} onChange={evt => updatePersonData(evt, 'postal_code')}/>

                        :
                          <span> XXXXX </span>

                        }

                      </div>
                    </div>
                    <div class=' input-group'>
                      <label className='add_entry_label_modal'>Country &nbsp;<em  class="required">*</em></label>
                      <div style={{clear: "both"}}></div>
                      <div  class="add_modal_div txt-field-container-modal">
                      { (this.state.person_to_update.country == '' || this.state.person_to_update.people_id == this.props.people_id  || this.state.person_to_update.country_is_edited ) ?
                        <select className="modal_input_half right_padding"  value={this.findCountry(this.state.person_to_update.country)} onChange={(e) => updatePersonData(e, 'country')} >
                          <option value="-1">Select...</option>
                          {
                              countries_array.map((country,index) => {
                                return (
                                    <option value={`${country}`}>
                                        {country}
                                    </option>
                                )
                              })
                          }
                        </select>
                      :
                        <span> {this.state.person_to_update.country} </span>

                      }
                        
                      </div>
                    </div>
                    
                  </div>
              </li>
              <li className='entry_people_li'>
                <div class="add_modal_div my-row">
                  <div class = 'input-group-full'>
                  <label className='add_entry_label_modal'>Email Address &nbsp;<em  class="required">*</em></label>
                  <div style={{clear: "both"}}></div>
                  <div  class="add_modal_div right_padding">
                      { (this.state.person_to_update.email_address == '' || this.state.person_to_update.people_id == this.props.people_id || this.state.person_to_update.email_address_is_edited ) ?
                        <input type="text" name="email_address" class="modal_input_right" id='txt_add_people_email_address' value={this.state.person_to_update.email_address} onChange={evt => updatePersonData(evt, 'email_address')}/>

                      :
                        <span> XXXXXXXXXXXXXXXXXXXXXXXX </span>

                      }
                  </div>
                  </div>
                </div>
              </li>
              <li className='entry_people_li'>
                  <div class="add_modal_div my-row">
                    <div class=' input-group'>
                      <label className='add_entry_label_modal'>Mobile &nbsp;<em  class="required">*</em></label>
                      <div style={{clear: "both"}}></div>
                      <div class="txt-field-container-modal right_padding" >
                        { (this.state.person_to_update.mobile_phone == '' || this.state.person_to_update.people_id == this.props.people_id || this.state.person_to_update.mobile_phone_is_edited) ?
                            <input type="text" name="mobile" id='txt_add_people_mobile' class="modal_input_half"  value={this.state.person_to_update.mobile_phone} onChange={evt => updatePersonData(evt, 'mobile_phone')}/>
                          :
                            <span> (XXX) XXX-XXXX </span>

                        }

                      </div>
                    </div>
                    <div class=' input-group'>
                      <div  class="add_modal_div txt-field-container-modal">
                          
                              <label className='add_entry_label_modal'>Phone Number</label>
                              <div style={{clear: "both"}}></div>
                              <div class="input-box txt-field-container-modal right_padding">
                                { (this.state.person_to_update.phonenumber == '' || this.state.person_to_update.people_id == this.props.people_id  || this.state.person_to_update.phonenumber_is_edited ) ?
                                  <input  type="text" name="phone_number" id="txt_add_people_phone_number" class="modal_input_half" value={this.state.person_to_update.phonenumber} onChange={evt => updatePersonData(evt, 'phonenumber')}/>

                                  :
                                    <span> (XXX) XXX-XXXX </span>

                                  }
                              </div>
                          
                      </div>
                    </div>
                    
                  </div>
              </li>
              {/* Emergency Contact Information */}
              <li className='entry_people_li'>
                  <div className="add_modal_div my-row">
                    {/* Emergency Contact Name */}
                    <div className='input-group'>
                      <label className='add_entry_label_modal'>Emergency Contact</label>
                      <div style={{clear: "both"}}></div>
                      <div className="txt-field-container-modal right_padding">
                        <input type="text" name="emergency_contact" id='txt_add_emergency_contact' className="modal_input_half"  value={this.state.person_to_update.emergency_contact} onChange={evt => this.updatePersonData(evt, 'emergency_contact')}/>
                      </div>
                    </div>
                    {/* Emergency Contact Number */}
                    <div className=' input-group'>
                      <label className='add_entry_label_modal'>Emergency Number</label>
                      <div style={{clear: "both"}}></div>
                      <div className="txt-field-container-modal right_padding">
                        <input type="text" name="emergency_phone" id='txt_add_people_emergency_phone' className="modal_input_half"  value={this.state.person_to_update.emergency_phone} onChange={evt => this.updatePersonData(evt, 'emergency_phone')}/>
                      </div>
                    </div>
                  </div>
              </li>
              <hr style={{marginTop: '30px'}} />
              <li className='entry_people_li'>
                <div>
                  <label className='add_entry_label'>MEMBERSHIPS</label>
                </div>
              </li>
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                {/* // <div> */}
                  {
                    this.props.people_organizations.map((membership_organization,index) => {
                    return (
                      <div className='add_modal_div modal-membership-div'>
                        <div style={{clear: "both"}}></div>
                        <label class='membership_label add_entry_label'>{membership_organization.code}</label>
                        <div className='membership_input_div'>
                        { (this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships) != '' && this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships,true)?.readonly  && !this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships,true)?.is_edited) ?
                          <span>{this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships)}</span>
                        :
                          <input class='modal_input' type="text" name="membership" id={"txt_add_people_membership_"+membership_organization.code}  value={this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships)} onChange={evt => updatePersonData(evt, membership_organization.code, true)}/>
                        }
                        </div>

                      </div>
                    )
                    })
                  }
                {/* // </div> */}
              </li>
              <li className='entry_people_li'>
                <div style={{clear: "both"}}></div>
                <div id='add_people_warning' className='required'>
                  {
                    typeof this.state.update_people_error_msg == 'string' ?
                    this.state.update_people_error_msg 
                    :
                    this.state.update_people_error_msg.map((error, index) => {
                      return(
                        <>
                          {error}
                          <br/>
                        </>
                      )
                    })
                  }
                </div>
                <div class='required float_right'>
                    * Required Fields
                  </div>
              </li>
            </ul>
          </form>
        </div>
        <div class='continue-button-div'>                                      
          <button class='sgl-button float_right horse_search-button' onClick={() => {closePeopleModal()}}>
            Cancel
          </button>
          <button class='sgl-button float_right horse_search-button' onClick={()=>{updatePerson()}}>
            Save
          </button>
        </div>

      </UpdateModal>
    )
  }

  validateSelectedPeople(){
    const j_rider_without_parent = this.state.riders.find(r => r.is_junior && (!r.parent_guardian_id || r.parent_guardian_id == 0));
      if (this.props.restrict_junior_riders && j_rider_without_parent) {
        this.setState({ people_validate_error: `Please select Parent/Guardian of Junior Riders.` });
        return;
     }
    const entry_data = {
      EntryRiders: this.state.riders.map( (rider) =>{
        return(
          {
            rider_id: rider.people_id,
            parent_guardian_id: rider.parent_guardian_id ??0
          }
        )
      } ),
      responsibleparty_id: this.state.selected_responsible.people_id,
      ec_responsibleparty_id: this.state.selected_ec_responsible?.people_id,
      trainer_id: this.state.selected_trainer.people_id,
      entryowner_id: this.state.selected_owner.people_id,
      prizemoneyrecipient_id: this.state.selected_prize.people_id
    }

    axios.post(this.sgl_webservice_validate_save_entry, {
      entry_data,
      entry_id: this.props.entry.entry_id,
      show_id: this.props.show_data.show_id,
      company_id: this.props.show_company.company_id,
      customer_id: this.context.company_id,
    }).then( (response) => {
      
      if(response.data.success){
        this.setState({
          people_validate_error:""
        })

        this.props.setSelectedPeople([
          this.state.riders,
          this.state.selected_trainer,
          this.state.selected_owner,
          this.state.selected_prize,
          this.state.selected_responsible,
          this.state.selected_ec_responsible
        ])
        this.props.changeSelection('signature');

      }
      else{
        this.setState({
          people_validate_error:response.data.error
        })
      }
    })
  }
  
  render(){
    if(this.state.show_people_search){
      return(
        <div class="sgl-plugin">
        <this.SearchPeople/>
        </div>
      )
    }
    return(  
      <div id='step_3' className='add_entry_people add-entry-div'> 
        <ul>    
          <li className='entry_people_li'>
            <p className="add-entry-p">Select people to be associated with this entry by:</p>
          </li>
          <li className='entry_people_li'>
            <p className="add-entry-p">
              - Select from the dropdown lists; people who have been associated with you in the past. You can manage this list on Account page <br/>
              - If they are not listed, please click the 'Search' button.
            </p>
          </li>
          <li id="HorseRow" className='entry_people_li'>
              <label class="sgl-label-border">Horse</label>
              {/* <hr className='hr_divider'/> */}
              <div style={{clear: "both"}}></div>
              <div class="input-box">
                  {this.props.selected_horse.name} 
                  {/* may get it from api */}
              </div>
          </li>
          <li id="RiderRow" className='entry_people_li'>
            <label class=" sgl-label-border"> Rider&nbsp;<em class='required'>*</em></label>
            <div style={{clear: "both"}}></div>
                {/* <div class="input-box"> */}
                {
                  this.state.riders?.map((rider, index) => {
                    //this.state.selected_rider.people_id?this.state.selected_rider.people_id:'-4'
                    return(
                      <div id={"RiderRow"+(index+1)} className='rider_row'>
                        <div class="people_selection_div">
                          <select id="rider" class="input-height people_selection" value={ rider?.people_id ? rider.people_id : "-4"  } onChange={(e) => this.onPersonSelect(e, 'rider',index,true)}>
                            <option value="-4">Select...</option>
                            {
                                this.props.people_list
                                .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                .map((person,index) => {
                                return (
                                    <option value={`${person.people_id}`}>
                                        {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                    </option>
                                )
                                })
                            }
                          </select>
                        </div>
                        <div class="icon_container display_on_mobile">
                          <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('rider,'+index)}}>
                            <img class="search_icon" src={search_icon} />
                          </a>
                        </div>
                        <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={()=>{this.showPeopleSearch('rider,'+index)}}>
                            Search
                        </button>
                        {rider.is_junior && (
                          <div className="people_selection_div" style={{ marginTop: '10px',marginBottom: '15px' }}>
                            <label className="sgl-label-border" style={{ marginRight: '10px' }}>
                              Parent/Guardian
                            </label>

                            <div style={{ display: 'flex', alignItems: 'flex-start'}}>
                              <select
                                className="input-height people_selection"
                                style={{ flex: 'none' }}
                                value={rider.parent_guardian_id || '0'}
                                onChange={e => {
                                  rider.parent_guardian_id = e.target.value;
                                  this.setState({ riders: this.state.riders });
                                }}
                              >
                                <option value="0">Select...</option>
                                {(rider.parents_list || []).map(parent => (
                                  <option key={parent.people_id} value={parent.people_id}>
                                    {parent.fl_name || parent.name}
                                    {parent.status === 'pending' ? ' (PENDING)' : ''}
                                  </option>
                                ))}
                                {(this.state.governing_organization != 'EC' && this.state.selected_trainer && JSON.stringify(this.state.selected_trainer) !== '{}' && this.state.selected_trainer.people_id != '-4') &&
                                  !rider.parents_list?.some(parent => parent.people_id == this.state.selected_trainer.people_id) && (
                                  <option key={this.state.selected_trainer.people_id} value={this.state.selected_trainer.people_id}>{this.state.selected_trainer.fl_name} (TRAINER)</option>
                                )}
                              </select>
                              {!this.state.loading_parents && (!rider.parents_list || rider.parents_list.length === 0) && (
                                  <button
                                    className="search_button sgl-button display_on_desktop"
                                    type="button"
                                    title="Search"
                                    onClick={() => this.showPeopleSearch('parent,' + index)}
                                    style={{ marginLeft: '10px' }}
                                  >
                                    Search
                                  </button>
                              )}
                            </div>
                              {!this.state.loading_parents && (!rider.parents_list || rider.parents_list.length === 0) && (
                                <div class="icon_container display_on_mobile">
                                  <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('parent,'+index)}}>
                                    <img class="search_icon" src={search_icon} />
                                  </a>
                                </div>
                              )} 
                          </div>
                        )}
                        {
                          ( index >= 0 && this.state.riders.length > 1 ) &&
                          <a class="">    <img src={delete_image} class="placing-icon"  style={{ width: "16px", height: "16px" }}  onClick={() => this.removeRider(index)}/></a>
                        }
                        {
                          rider?.remove_error &&
                          <div id='add_rider_error' >
                            <p class="required">{rider.remove_error}</p>
                          </div>   
                        }
                        {
                          ( rider?.people_id || rider?.rider_id ) && 
                          <div id={"detail_rider"+(index+1)} className="detail_box">
                            {/* process.env.REACT_APP_PUBLIC_URL  sid=this.state.selected_show*/}
                            <Link to={'/people/detail?pid='+rider.people_id+'&sid='+this.props.show_data.show_id}><b>{rider.fl_name}</b></Link>
                            <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(rider,this.state.governing_organization)}</p>
                            <div><a onClick={this.openUpdatePeopleModel(rider, 'rider,'+index)}><b>{this.getPeopleUpdateMsg(rider, 'rider')}</b></a></div>
                          </div>
                        }

                        <div style={{clear: "both"}}></div>
                      </div>       
                    )

                  })
                }

                {
                  this.state.riders.length < this.props.max_rider_limit ?
                  <div>
                    <button  className="add_rider_button horse_search-button sgl-button" id='add_rider_button' type="button" title="AddRider" onClick={()=>{ this.addRider() }}>
                        + Add another Rider
                    </button>
                  </div>
                  :
                  <div id='add_rider_error' >
                    <p class="required">Additional Riders must be added through the show office.</p>
                  </div>               
                }

                {
                  ( this.state.riders.length > 1 ) &&
                  <div id="RiderRemove" >
                    <p>Click <img src={delete_image} class="placing-icon"  style={{ width: "16px", height: "16px" }} /> To Remove Rider</p>
                  </div>
                }
          </li>
          <li id="TrainerRow" className='entry_people_li'>
            <div style={{clear: "both"}}></div>
            <label class="sgl-label-border"> {this.state.governing_organization == 'EC'?'Coach':'Trainer'}&nbsp;<em class="required">*</em></label>
            {/* <hr className='hr_divider'/> */}
            <div style={{clear: "both"}}></div>
            <div class="people_selection_div">
                {/* <div class="input-box"> */}
                    <select id="trainer" class="input-height people_selection" value={this.state.selected_trainer?.people_id ? this.state.selected_trainer?.people_id : "-4" } onChange={(e) => this.onPersonSelect(e, 'trainer')}>
                        <option value="-4">To Be Determined</option>
                             {
                                 this.props.people_list
                                 .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                 .map((person,index) => {
                                 return (
                                     <option value={`${person.people_id}`}>
                                         {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                     </option>
                                 )
                                 })
                             }
                    </select>
            </div>
            <div class="icon_container display_on_mobile">
              <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('trainer')}}>
                <img class="search_icon" src={search_icon} />
              </a>
            </div>
            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbTrainer" name="sbTrainer" onClick={()=>{this.showPeopleSearch('trainer')}}>
                Search
            </button>
            <div id="detail_owner" className="detail_box">
              <Link to={'/people/detail?pid='+this.state.selected_trainer?.people_id+'&sid='+this.props.show_data.show_id}><b>{this.state?.selected_trainer?.fl_name}</b></Link>
              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_trainer,this.state.governing_organization)}</p>
              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_trainer, 'trainer')}><b>{this.getPeopleUpdateMsg(this.state.selected_trainer, 'trainer')}</b></a></div>
            </div>
          </li>
          <li id="OwnerRow" className='entry_people_li'>
            <div style={{clear: "both"}}></div>
            <label class="sgl-label-border">  Owner&nbsp;<em class="required">*</em></label>
            {/* <hr className='hr_divider'/> */}
            <div style={{clear: "both"}}></div>
            <div class="people_selection_div">
                {/* <div class="input-box"> */}
                    <select id="owner" class="input-height people_selection" value={this.state.selected_owner?.people_id ? this.state.selected_owner?.people_id : "-4"} onChange={(e) => this.onPersonSelect(e, 'owner')}>
                        <option value="-4">Select an Owner</option>
                             {
                                 this.props.people_list
                                 .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                 .map((person,index) => {
                                 return (
                                     <option value={`${person.people_id}`}>
                                         {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                     </option>
                                 )
                                 })
                             }
                    </select>
            </div>
            <div class="icon_container display_on_mobile">
              <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('owner')}}>
                <img class="search_icon" src={search_icon} />
              </a>
            </div>
            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbOwner" name="sbOwner" onClick={()=>{this.showPeopleSearch('owner')}}>
                Search
            </button>
            <div id="detail_owner" className="detail_box">
              <Link to={'/people/detail?pid='+this.state.selected_owner?.people_id+'&sid='+this.props.show_data.show_id}><b>{this.state?.selected_owner?.fl_name}</b></Link>
              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_owner,this.state.governing_organization)}</p>
              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_owner, 'owner')}><b>{this.getPeopleUpdateMsg(this.state.selected_owner, 'owner')}</b></a></div>
            </div>
          </li>
          <li id="PrizeRow" className='entry_people_li'>
            <div style={{clear: "both"}}></div>
            <label class="sgl-label-border">  Prize Money Recipient&nbsp;<em class="required">*</em></label>
            {/* <hr className='hr_divider'/> */}
            <div style={{clear: "both"}}></div>
            <div class="people_selection_div">
                {/* <div class="input-box"> */}
                    <select id="prize" class="input-height people_selection" value={this.state.selected_prize?.people_id ? this.state.selected_prize?.people_id : "-4"} onChange={(e) => this.onPersonSelect(e, 'prize')}>
                        <option value="-4">To Be Determined</option>
                             {
                                 this.props.people_list
                                 .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                 .map((person,index) => {
                                 return (
                                     <option value={`${person.people_id}`}>
                                         {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                     </option>
                                 )
                                 })
                             }
                    </select>
            </div>
            <div class="icon_container display_on_mobile">
              <a className="display_on_mobile" >
                <img class="search_icon" src={search_icon} />
              </a>
            </div>
            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbPrize" name="sbPrize" onClick={()=>{this.showPeopleSearch('prize')}}>
                Search
            </button>
            <div id="detail_owner" className="detail_box">
              <Link to={'/people/detail?pid='+this.state.selected_prize?.people_id+'&sid='+this.props.show_data.show_id}><b>{this.state?.selected_prize?.fl_name}</b></Link>
              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_prize,this.state.governing_organization)}</p>
              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_prize, 'prize')}><b>{this.getPeopleUpdateMsg(this.state.selected_prize, 'prize')}</b></a></div>
            </div>
          </li>
          <li id="ResponsiblePersonRow" className='entry_people_li'>
            <div style={{clear: "both"}}></div>
            <label class="sgl-label-border">  Responsible Person&nbsp;<em class="required">*</em></label>
            {/* <hr className='hr_divider'/> */}
            <div style={{clear: "both"}}></div>
            <div class="people_selection_div">
                {/* <div class="input-box"> */}
                    <select id="responsible" class="input-height people_selection" value={this.state.selected_responsible?.people_id ? this.state.selected_responsible?.people_id : "-4"} onChange={(e) => this.onPersonSelect(e, 'responsible')}>
                        <option value="-4">To Be Determined</option>
                             {
                                 this.props.people_list
                                 .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                 .map((person,index) => {
                                 return (
                                     <option value={`${person.people_id}`}>
                                         {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                     </option>
                                 )
                                 })
                             }
                    </select>
            </div>
            <div class="icon_container display_on_mobile">
              <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('responsible')}}>
                <img class="search_icon" src={search_icon} />
              </a>
            </div>
            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbResponsible" name="sbResponsible" onClick={()=>{this.showPeopleSearch('responsible')}}>
                Search
            </button>
            <div id="detail_owner" className="detail_box">
              <Link to={'/people/detail?pid='+this.state.selected_responsible?.people_id+'&sid='+this.props.show_data.show_id}><b>{this.state?.selected_responsible?.fl_name}</b></Link>
              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_responsible,this.state.governing_organization)}</p>
              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_responsible, 'responsible')}><b>{this.getPeopleUpdateMsg(this.state.selected_responsible, 'responsible')}</b></a></div>
            </div>
          </li>
          {(this.state.governing_organization == 'EC') && 
            <li id="ECResponsiblePersonRow" className='entry_people_li'>
              <div style={{clear: "both"}}></div>
              <label class="sgl-label-border">  EC Responsible Person&nbsp;<em class="required">*</em></label>
              <div style={{clear: "both"}}></div>
              <div class="people_selection_div">
                      <select id="ec_responsible" class="input-height people_selection" value={this.state.selected_ec_responsible?.people_id ? this.state.selected_ec_responsible?.people_id : "-4"} onChange={(e) => this.onPersonSelect(e, 'ec_responsible')}>
                          <option value="-4">To Be Determined</option>
                              {
                                  this.props.people_list
                                  .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                  .map((person,index) => {
                                  return (
                                      <option value={`${person.people_id}`}>
                                          {person.lf_name} {person.people_id == this.props.people_id? '(ME)' : ''}
                                      </option>
                                  )
                                  })
                              }
                      </select>
              </div>
              <div class="icon_container display_on_mobile">
                <a className="display_on_mobile" onClick={()=>{this.showPeopleSearch('ec_responsible')}}>
                  <img class="search_icon" src={search_icon} />
                </a>
              </div>
              <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbec_responsible" name="sbec_responsible" onClick={()=>{this.showPeopleSearch('ec_responsible')}}>
                  Search
              </button>
              <div id="detail_owner" className="detail_box">
                <Link to={'/people/detail?pid='+this.state.selected_ec_responsible?.people_id+'&sid='+this.props.show_data.show_id}><b>{this.state?.selected_ec_responsiblea?.fl_name}</b></Link>
                <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_ec_responsible,this.state.governing_organization)}</p>
                <div><a onClick={this.openUpdatePeopleModel(this.state.selected_ec_responsible, 'ec_responsible')}><b>{this.getPeopleUpdateMsg(this.state.selected_ec_responsible, 'ec_responsible')}</b></a></div>
              </div>
            </li>
          }
          <li className="display_none">
            <this.PeopleUpdateModal/>
          </li>
        </ul>
        <div style={{clear: "both"}}></div>
        <div id='add_people_warning' className='required'>
          {this.state?.people_validate_error}
        </div>
        <div class='continue-button-div'>
          <button class='sgl-button float_right horse_search-button' onClick={()=>{this.validateSelectedPeople()}}>
            Continue
          </button>
        </div>
      </div>    
    )
  }
}

class DigiSignPhone extends React.Component{
  state = {
      people_id: '',
      phoneNumber: '',
      status: true,
      // mobile_phone: {
      //     isValid: false,
      //     rawValue: null,
      //     countryData: null,
      //     formattedValue: "",
      //     extension: null,
      //   }
  }

componentDidMount() {
  // var phone_component = window.intlTelInput(this.el, {
  //   dropdownContainer: document.body,
  //   formatOnDisplay: true,
  //   nationalMode: true,
  //   placeholderNumberType: "MOBILE",
  //   preferredCountries: ['us', 'ca'],
  //   initialCountry: 'us',
  //   utilsScript: "https://showgroundslive.com/js/utils.js",
  // });

  var people_id = this.props.people_id;
  // let phone_component = window.iti;

  this.setState({people_id: people_id, index: this.props.index});
  //   if(this.state.status) {
  //     document.getElementById('phone_number_' + people_id).value = this.state.phoneNumber;
  //     document.querySelector("#valid_msg_" + people_id).classList.remove('hide');
  //   } else {
  //     document.getElementById('phone_number_' + people_id).value = '';
  //     document.querySelector("#valid_msg_" + people_id).classList.add('hide');
  //   }


}

componentWillUnmount() {
}


handlePhoneChange = (status, phoneNumber, country) => {
  this.setState({ 'phoneNumber': phoneNumber, 'status':status });
  // var phone_number = '+' + phoneNumber.replace(/\D/g, "");


  if(status) {
      document.getElementById('phone_number_' + this.props.people_id).value = phoneNumber;
      document.querySelector("#valid_msg_" + this.props.people_id).classList.remove('hide');
    } else {
      document.querySelector("#valid_msg_" + this.props.people_id).classList.add('hide');
      document.getElementById('phone_number_' + this.props.people_id).value = '';
    }
    this.props.onUpdate(phoneNumber, this.props.index);
};

render(){
  return (
    <div style={{display:'inline-block'}}>
      {/* <input
        name={"phone_number_plugin_" + this.props.people_id}
        id={"phone_number_plugin_" + this.props.people_id} 
        ref={el => this.el = el}
        onChange={evt => this.updatePhone(evt.target.value)}
        value={this.props.phonenumber}
      /> */}
      <IntlTelInput
                  style={{
                    width: "100%",
                  }}
                  // allowDropdown={true}
                  // dropdownContainer={document.body}
                  // nationalMode={true}
                  formatOnDisplay={true}
                  // placeholder={"MOBILE"}
                  initialCountry={"us"}
                  // utilsScript={"https://showgroundslive.com/js/utils.js"}
                  preferredCountries={["us", "ca"]}
                  // onPhoneNumberChange={this.handlePhoneNumberChange}
                  onPhoneNumberChange={this.handlePhoneChange}

  
                  // onBlur={handleBlur}
                  // onKeyUp={reset}
                  name={"phone_number_plugin_" + this.props.people_id}
                  id={"phone_number_plugin_" + this.props.people_id} 
                  // ref={el => this.el = el}
                  // onChange={evt => this.updatePhone(evt.target.value)}
                  value={this.props.phonenumber}
                  
                />
    </div>
  );
}
}

class DigitalSignatureVerification extends React.Component{
  
  get sgl_webservice_edit_entry() {
    return this.context.nestApiUrl + '/entries/getEditEntry';
  }

  get sgl_webservice_save_entry() {
    return this.context.nestApiUrl + '/entries/saveEditEntry';
  }

  get sgl_webservice_shows_list() {
    return this.context.nestApiUrl + '/shows';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  get sgl_webservice_iphone() {
    return this.context.sglApiUrl + '/iphonev2/addentryv2/';
  }

  get sgl_webservice_validate_remove_rider() {
    return this.context.nestApiUrl + '/entries/validateRemoveRider';
  }

  get sgl_webservice_validate_horse_change() {
    return this.context.nestApiUrl + '/entries/validateHorseChange';
  }

  get sgl_webservice_validate_save_entry() {
    return this.context.nestApiUrl + '/entries/validateSaveEntry';
  }
  
  constructor(props){
    super(props);
    //set roles of riders
    this.state = {
      digital_sign_people_list: [],
      disallow_agent_signature: false,
      governing_organization: this.props?.governing_organization,
      formatted_phone_numbers: [],
      digisign_error_msg: "",
      rtos: {},
    }

  }

  componentDidMount(){
    let riders_filtered_list = this.props.selected_riders.filter( (rider) => {
        const isInEntryRiders = this.props.entry.EntryRiders.find((er) => er.rider_id == rider.people_id && er.parent_guardian_id == rider.parent_guardian_id)
        return isInEntryRiders ? false : true;
      } )
      .map(rider => ({ ...rider })); 

    const rtos = {
      //filtering for only changed or different people
      rider: riders_filtered_list,
      trainer: this.props.entry.trainer_id != this.props.selected_trainer.people_id ? [ this.props.selected_trainer ] : [],
      owner: this.props.entry.entryowner_id != this.props.selected_owner.people_id ? [ this.props.selected_owner ] : [],
      billTo: this.props.entry.responsibleparty_id != this.props.selected_responsible.people_id ? [ this.props.selected_responsible ] : [],
      ec_rp: (this.props.entry.ec_responsibleparty_id && this.props.entry.ec_responsibleparty_id != this.props.selected_ec_responsible?.people_id) ? [ this.props.selected_ec_responsible ] : [],
    }

    let isChanged = false;
    for(let rto in rtos){
      if(rtos[rto].length > 0 ) {  //if any changed person
        isChanged = true;
        break;
      }
    }

    if(isChanged){
      if(rtos.rider.length > 0){
        for(let rider_rec of rtos.rider){

          if(rider_rec.parent_guardian_id != 0){
            rider_rec.people_id = rider_rec.parent_guardian_id
            rider_rec.first = ''
            rider_rec.last_name = ''
          }
        }
      }
      this.getSignatureVerificationList(rtos);
    }
    else{
      this.props.saveEntry();
    }
  }

  getDigitalSignatureVerification(entry_data){
    axios.post(this.sgl_webservice_iphone+'DigitalSignatureVerification',new URLSearchParams({
          entry_data : entry_data,
          company_id: this.context.company_id
        })
      ).then(results => {
        if(results.data?.people){
          results.data.people = results.data.people.filter( people => people?.people_id )
          if(results.data.people.length > 0){  //not null
            //poping null value from people if any
            this.setState({
              digital_sign_people_list: results.data.people,
              disallow_agent_signature: results.data.disallow_agent_signature
            })
          }
          else{
            this.onContinueBtn(); //continue to thank you
          }
        }
        
    })
  }

  getSignatureVerificationList(persons){
    var entry_data = {
      shows: {
        show_id: this.props.current_show
      },
      persons: persons,
    }
    console.log(entry_data)
    var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(entry_data))));

    this.getDigitalSignatureVerification(encoded_data);
  }

  getFormattedPhoneNumber = (number, index) => {
    let newNumber = number;
    if(this.state.formatted_phone_numbers.indexOf(index) < 0){
      if(newNumber[0] != '0' && newNumber[0] != '(' && newNumber[0] != '+'){
        newNumber = number.replace(/[+]/g, '')
        newNumber = newNumber[0] != '0' && newNumber[0] != '(' ? '+' + newNumber : newNumber
        this.setState({ formatted_phone_numbers: [...this.state.formatted_phone_numbers, index] })
      }
    }
    return newNumber
  }

  // getDataRoles(roles){
  //   var roles_str = roles.join(', ');
  //   if(this.state.governing_organization == 'EC'){
  //     return roles_str.replace('Trainer', 'Coach')
  //   }
  //   return roles_str;
  // }

  getDataRoles(roles, people_id){

      let updatedRoles = [...roles]; // Create a copy to modify

      if (people_id !== undefined && people_id !== null && updatedRoles.includes('Rider')) {
        const selectedRidersList = this.props.selected_riders; // Get the list from state
        // Find the original rider from the state's selected list by their ID
        const originalRider = selectedRidersList.find(r => r.people_id == people_id);
        if(!originalRider && selectedRidersList.find(r => r.parent_guardian_id == people_id)){
          updatedRoles = updatedRoles.map(role =>
              role === 'Rider' ? 'Rider Parent' : role
          );
        }

      }

      var roles_str = updatedRoles.join(', ');

      if(this.state.governing_organization === 'EC'){
        return roles_str.replace('Trainer', 'Coach')
      }
      return roles_str;
    }

  updateDigitalSignaturePhone(value, index ){
    this.state.digital_sign_people_list[index].phone = value;
    this.setState({digital_sign_people_list: this.state.digital_sign_people_list});
  }

  agentWillSign(e,index){
    const agent =this.state.digital_sign_people_list[index];
    if(!agent?.agent_will_sign){
      agent.agent_will_sign = true
    }
    else{
      agent.agent_will_sign = !agent.agent_will_sign
    }

  }

  signature_selected = (e) => {
    var digisignerror = false;
    var digisignmsg = '';
  
    this.state.digital_sign_people_list.forEach(digital_sign_people => {
      if(!digital_sign_people.phone_number_verified && document.getElementById('phone_number_' + digital_sign_people.people_id).value == '' && !digital_sign_people?.agent_will_sign ){
        digisignerror = true;
        digisignmsg += "<br/> Please provide valid phone for " + digital_sign_people.fl_name;
      }
    });
      if (!digisignerror) {
        this.setState({
          digisigin_error_msg:"",
        })
        this.onContinueBtn();
      } else {
        this.setState({
          digisign_error_msg: digisignmsg
        }); 
      }

  }

  onContinueBtn(){
    this.props.setDigitalSignature(this.state.digital_sign_people_list)
    // this.props.saveEntry();
  }

  render(){
    if(this.props.saveErrorMessage != ""){
      return(
        <div id='step_9' className='add_entry_class add-entry-div'>             
          <ul>    
            <li className='entry_people_li'>
              <p className="add-entry-p required">
                {this.props.saveErrorMessage}
              </p>
            </li>
          </ul>
        </div>
      )
    }

    return(
      <div id='step_9' className='add_entry_class add-entry-div'>             
        <ul>    
          <li className='entry_people_li'>
            <p className="add-entry-p">
              Please enter mobile numbers of People connected to entry to sign the waiver online.
            </p>
          </li>

          <li id="SignatureRow" className='entry_people_li'>
            <div style={{clear: "both"}}></div>
            <table className="table table-striped table-hover">
                <thead class="classes-header">                    
                    <tr class="sgl-primary-header">
                      <th>Name</th>
                      <th >Mobile Number</th>
                      <th></th>
                    </tr>
                </thead>
                <tbody>
                { (this.state.digital_sign_people_list.length > 0) &&
                      this.state.digital_sign_people_list.map((data, index) => {
                        let phoneNumber = this.getFormattedPhoneNumber(data.phone, index)
                        return (
                          <tr class="sgl-anchor">
                            <td colspan="">{data.fl_name} ({this.getDataRoles(data.roles, data.people_id)})</td>
                            {data?.phone_number_verified && 
                            <td class=''>
                              {data.phone}
                            </td>
                            }
                            {!data?.phone_number_verified && 
                            <td class=''>
                              <input 
                                type="hidden" 
                                class="digital_signature_phonenumber" 
                                id={"phone_number_" + data.people_id} 
                                name={"phone_number_" + data.people_id} 
                                // value={data.phone}
                                // onChange={evt => this.updateDigitalSignaturePhone(evt, index)}
                              />
                              <DigiSignPhone people_id={data.people_id} phonenumber={phoneNumber} onUpdate={this.updateDigitalSignaturePhone.bind(this)} index={index}/>
                              <span id={"valid_msg_" + data.people_id} class="hide">
                                <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{'padding-left':'5px', width:'16px', height:'16px'}} />
                              </span>

                            </td>
                            }

                            <td>
                              {(!data.roles.includes('Trainer')) && !this.state.disallow_agent_signature && 
                                <div class='agent_will_sign'>
                                <input type="checkbox" name={"agent_will_sign_" + data.people_id} id={"agent_will_sign_" + data.people_id} onChange={(e)=>{this.agentWillSign(e,index)}} index={index}/>
                                <label for={'agent_will_sign_' + data.people_id}>&nbsp;{this.state.governing_organization == 'EC'?'Coach ':'Trainer '}will Sign</label>
                              </div>
                              }
                            </td>
                          </tr>
                        )
                      })
                    }
                </tbody>
            </table>
            <div style={{clear: "both"}}></div>
            {
              this.state.digisign_error_msg != "" 
              &&
            <div id='step_9_warning' className='required' dangerouslySetInnerHTML={{ __html: this.state.digisign_error_msg }}></div>
            }
          </li>
        
        </ul>

        {/* <hr/> */}
        <div class='continue-button-div'>
          <div class='required float_right'>
            * Required Fields
          </div>
          <br class="sgl-mb-5"/>
          {/* <span id="create-entry-please-wait" class='display_none float_right'><img src={indicator_icon} /></span> */}
          <button id='continue-signature' class='sgl-button float_right' onClick={(e)=>{this.signature_selected(e)}}>
            Continue
          </button>
        </div>
    </div>
    )
  }
}


SelectPeople.contextType = SglContext;
SelectHorse.contextType = SglContext;
DigitalSignatureVerification.contextType = SglContext;
EditEntry.contextType = SglContext;
export default EditEntry;